import React, { useEffect, useState, useMemo, useRef } from 'react';
import Container from '../../../Container/Container'
import { useNavigate, useLocation, Link } from 'react-router';
import { useForm, Controller } from "react-hook-form";
import { get, ImageUrl } from '../../../ApiServices/ApiServices';
import Select from 'react-select';
import { LeafyGreen, Search } from "lucide-react";
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { Image } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { setSize, clearSize, setShirtSize } from '../../../redux/profileSlice';
import { useDebounce } from 'use-debounce';

function Memberstyle({ onSubmit, onNext, onBack, ticket, account, initialValues }) {
    const { register, handleSubmit, formState, control, watch, getValues, trigger, setValue, clearErrors } = useForm({
        defaultValues: initialValues
    });
    const { errors } = formState;
    const [debouncedWeight, setDebouncedWeight] = useState(null);
    const categoryErrorRef = useRef(null);

    // Create a debounced version of the weight value
    const [debouncedWeightValue] = useDebounce(watch("Weight"), 800);
    const [data, setdata] = useState([])
    const [sizes, setsizes] = useState([])
    const [sizesCategory, setsizesCategory] = useState([])
    const [showSleeve, setShowSleeve] = useState(true);
    const [selectedHeight, setSelectedHeight] = useState(initialValues.Height || "");
    const [coat, setcoat] = useState('')
    const [sizefilterid, setsizefilterid] = useState('')
    const [AllSize, setAllSize] = useState([])
    const [categoryName, setCategoryName] = useState('');
    const [isUserSelectedInsleeve, setIsUserSelectedInsleeve] = useState(false);
    const [isUserSelectedCategory, setIsUserSelectedCategory] = useState(false);

    const getLocalStorageItem = (key) => {
        try {
            const item = localStorage.getItem(key);
            if (item == null || item == "undefined") return null;
            return JSON.parse(item);
        } catch (error) {
            console.error(`Error parsing localStorage item "${key}":`, error);
            return null; // Fallback to null if JSON.parse fails
        }
    };
    const CoatstyleData = getLocalStorageItem('coatStyle');
    const [Coatstyle, setCoatstyle] = useState(CoatstyleData);
    const pantstyleData = getLocalStorageItem('pantstyle');
    const [Pantstyle, setPantstyle] = useState(pantstyleData);
    const shirtstyleData = getLocalStorageItem('shirtstyle');
    const [tempCoatSize, setTempCoatSize] = useState(null);
    const VeststyleData = getLocalStorageItem('Veststyle');
    const [Veststyle, setVeststyle] = useState(VeststyleData);
    const [waistSizes, setWaistSizes] = useState([]);
    const [HipSizes, setHipSizes] = useState([]);
    const [NeckSizes, setNeckSizes] = useState([]);
    const [InsleeveSizes, setInsleeveSizes] = useState([]);
    const [ShoesSizes, setshoesSizes] = useState([]);
    const [outseamSizes, setoutseamSizes] = useState([]);
    const [pantStyleSelected, setPantStyleSelected] = useState(false);
    const [orderForState, setOrderForState] = useState(initialValues?.order_for);
    const [uniqcoat, setuniqcoat] = useState([])
    const dispatch = useDispatch();
    const Resize = useSelector((state) => state.profile.size);
    const [MatchedItems, setMatchedItems] = useState([])
    const [coattype, setcoattype] = useState("")
    const [nonBoldMessage, setNonBoldMessage] = useState("");
    const navigate = useNavigate()
    const location = useLocation()
    const selectedCoatStyle = watch("Coat");
    const selectedVestStyle = watch("Vest");
    const selectedShoesStyle = watch("Shoes");
    const [disableSleeve, setDisableSleeve] = useState(false); // Track if Sleeve should be disabled
    const insleeveValidation = selectedCoatStyle ? { required: "Insleeve is required" } : {};
    const [orderFor, setOrderFor] = useState(initialValues.order_for || "Men");
    const pantStyleValue = watch("Pant");
    const [shirtStyleSelected, setShirtStyleSelected] = useState(false);
    const [coatid, setCoatid] = useState(localStorage.getItem('coatid')) || null;
    const [sizeid, setSizeid] = useState(localStorage.getItem('size')) || null;

    const [selectedCoatSize, setSelectedCoatSize] = useState(localStorage.getItem('coatid')) || null;

    const [defaultsize, setdefaultsize] = useState(null)
    const [Stoprender, setStoprender] = useState(true)
    const [selectedNeckSize, setSelectedNeckSize] = useState(initialValues?.ShirtSize || null);
    const shirtStyleValue = watch("Shirt");
    const [recommendationMessage, setRecommendationMessage] = useState('');
    const [recommendedCategoryDisplay, setRecommendedCategoryDisplay] = useState('');
    const [recommendedCategory, setRecommendedCategory] = useState(null);
    const weight = watch("Weight"); // Ensure weight updates
    const [shirtSize, setShirtSizes] = useState("");
    const [sizeRecommendationMsg, setSizeRecommendationMsg] = useState("");
    const [shirtSizeRecommendationMsg, setShirtSizeRecommendationMsg] = useState("");
    const [vestRecommendationMsg, setVestRecommendationMsg] = useState("");
    const [category, setCategory] = useState("");
    const [allSizes, setAllSizes] = useState([]);
    const ID = location.state?.ID;
    const [originalCategory, setOriginalCategory] = useState(null);
    const [coatStyles, setCoatStyles] = useState([]);
    const [selectedStyle, setSelectedStyle] = useState(null);
    const [coatStyleSizes, setCoatStyleSizes] = useState([]);
    const [pantStyles, setPantStyles] = useState([]);
    const [pantStyleSizes, setPantStyleSizes] = useState([]);
    const [selectedPantStyle, setSelectedPantStyle] = useState(null);
    const [selectedShirtStyle, setSelectedShirtStyle] = useState(null);
    const [availableSizesForStyle, setAvailableSizesForStyle] = useState([]);
    const [styleValidationMessage, setStyleValidationMessage] = useState('');
    const [categoryValidationMessage, setCategoryValidationMessage] = useState('');
    const [categorySizes, setCategorySizes] = useState({});
    const [availableSizes, setAvailableSizes] = useState([]);
    const [coatSizeValidation, setCoatSizeValidation] = useState({});
    const [debouncedSelectedPantStyle, setDebouncedSelectedPantStyle] = useState(selectedPantStyle);
    const [shoeColors, setShoeColors] = useState([]); // to store shoe colors extracted from data

    const CoatSizetext = watch("CoatSize")
    const VestColor = watch("VestColor")
    const shirt_size = watch("shirt_size")
    const ShoesSize = watch("ShoesSize")
    const Waistsize = watch("Waist")
    const ShoesData = getLocalStorageItem('Shoes');

    const [isInitialLoad, setIsInitialLoad] = useState(true);

    const [activeItem, setActiveItem] = useState(null);
    const [recommendedRange, setRecommendedRange] = useState(null);
    const [Shoesstyle, setShoesstyle] = useState(ShoesData || null);
    const [LabelcategoryName, setLabelcategoryName] = useState(categoryName || null)
    const [LebelCoat, setLebelCoat] = useState(CoatstyleData || null)
    const [Lebelpant, setLebelpant] = useState(pantstyleData || null)
    const [LebelShirt, setLebelShirt] = useState(shirtstyleData || null)
    const [LebelVest, setLebelVest] = useState(VeststyleData || null)
    const [LebelShoes, setLebelShoes] = useState(selectedShoesStyle || null)
    const [LebelCoatsize, setLebelCoatsize] = useState(CoatSizetext || null)
    const [Lebelpantsize, setLebelpantsize] = useState(Waistsize || null)
    const [LebelShirtsize, setLebelShirtsize] = useState(shirt_size || null)
    const [LebelVestsize, setLebelVestsize] = useState(VestColor || null)
    const [LebelShoessize, setLebelShoessize] = useState(ShoesSize || null)
    const profile = useSelector((state) => state.profile.profile);
    const [selectedCoatStyleForPants, setSelectedCoatStyleForPants] = useState(null);
    const [matchedPantStyles, setMatchedPantStyles] = useState(null);
    const [pantValidationMessage, setPantValidationMessage] = useState(''); // NEW - single message
    const [categoryMappings, setCategoryMappings] = useState({});
    // 🔄 Fetch matched pant style when coat style changes
    const fetchMatchedPantStyles = async (coatStyle) => {
        try {
            if (!coatStyle) {
                setMatchedPantStyles([]);
                return;
            }

            const api = `get-matched-pant-styles`;
            const response = await get(api);
            const allRows = response?.data || [];

            const matchedPantStyles = allRows
                .filter(item => String(item.style) === String(coatStyle))
                .map(item => item.match_pant_style);

            if (matchedPantStyles.length > 0) {
                setMatchedPantStyles(matchedPantStyles);
            } else {
                setMatchedPantStyles([]);
            }
        } catch (err) {
            setMatchedPantStyles([]);
            if (
                err?.message === "Invalid or expired token" ||
                err?.message === "Invalid Token"
            ) {
                localStorage.removeItem('token');
                navigate('/login');
            }
        }
    };

    useEffect(() => {
        if (initialValues?.Coat) {
            fetchMatchedPantStyles(initialValues.Coat);
        }
    }, [initialValues?.Coat]);

    useEffect(() => {
        if (selectedCoatStyleForPants) {
            fetchMatchedPantStyles(selectedCoatStyleForPants);
        } else {
            setMatchedPantStyles([]);
        }
    }, [selectedCoatStyleForPants]);

    // 🧠 Generate options list: bold + top for matched
    const getPantOptions = () => {
        const sorted = [...pants].sort((a, b) =>
            a.style.localeCompare(b.style, undefined, { numeric: true })
        );

        const options = sorted.map(item => ({
            value: item.style,
            label: `${item.style} ${item.description}`,
            isMatched: matchedPantStyles.includes(item.style)
        }));

        const matched = options.filter(opt => opt.isMatched);
        const others = options.filter(opt => !opt.isMatched);

        return [...matched, ...others];
    };
    const reorderNeckSizes = (options, boldBaseValues) => {
        const boldOptions = [];
        const afterBold = [];
        const beforeBold = [];

        const sortedBold = [...boldBaseValues].sort((a, b) => a - b);
        const minBold = sortedBold[0] ?? -Infinity;
        const maxBold = sortedBold[sortedBold.length - 1] ?? -Infinity;

        for (const option of options) {
            if (boldBaseValues.includes(option.baseValue)) {
                boldOptions.push(option);
            } else if (option.baseValue > maxBold) {
                afterBold.push(option);
            } else if (option.baseValue < minBold) {
                beforeBold.push(option);
            }
        }
        return [...boldOptions, ...afterBold, ...beforeBold];
    };

    const sortVestSizesWithLogic = (availableCoatSizes, uniqueSizes) => {
        const sizeOrder = {
            'BS': 1, 'BM': 2, 'BL': 3, '4FB': 4,
            'S': 10, 'M': 11, 'L': 12, 'XL': 13, 'XXL': 14, '3XL': 15,
            'SL': 20, 'ML': 21, 'LL': 22, 'XLL': 23, '2LL': 24, '3LL': 25, '4LL': 26
        };

        const getSizePriority = (size) => sizeOrder[size] || 999;

        const boldPriorities = uniqueSizes.map(size => getSizePriority(size));
        const maxBoldPriority = Math.max(...boldPriorities);

        // Separate items into categories
        const boldItems = [];
        const largerItems = [];
        const smallerItems = [];

        availableCoatSizes.forEach(item => {
            const isBold = uniqueSizes.includes(item.value);
            const priority = getSizePriority(item.value);

            if (isBold) {
                boldItems.push(item);
            } else if (priority > maxBoldPriority) {
                largerItems.push(item);
            } else {
                smallerItems.push(item);
            }
        });

        // Sort each category
        boldItems.sort((a, b) => getSizePriority(a.value) - getSizePriority(b.value)); // Bold: ascending
        largerItems.sort((a, b) => getSizePriority(a.value) - getSizePriority(b.value)); // Larger: ascending
        smallerItems.sort((a, b) => getSizePriority(a.value) - getSizePriority(b.value)); // Smaller: descending

        // Combine: Bold + Larger + Smaller
        return [...boldItems, ...largerItems, ...smallerItems];
    };

    useEffect(() => {
        if (categoryName && !LabelcategoryName) { // Only set if categoryName exists and label isn't set yet
            setLabelcategoryName(categoryName);
        }
    }, [categoryName]);


    const getNeckOptions = (allSizes, selectedShirt, sizesCategory, NeckSizes) => {
        if (!allSizes?.length) return [];
        let options = generateNeckSizes(allSizes);

        // 🔎 Filter depending on selected shirt type
        if (selectedShirt) {
            const { type } = selectedShirt;
            options = options.filter(option => {
                const base = option.baseValue;
                if (type === "Added Length") return base >= 18 && base <= 26;
                if (type === "Fitted") return base >= 14 && base <= 19;
                return true;
            });
        }

        // Determine bold base values
        let boldBaseValues = [];
        if (sizesCategory?.length) {
            const neckMin = parseFloat(sizesCategory[0]?.minNeck);
            const neckMax = parseFloat(sizesCategory[0]?.maxNeck);
            boldBaseValues = options
                .filter(opt => opt.baseValue >= neckMin && opt.baseValue <= neckMax)
                .map(opt => opt.baseValue);
        } else {
            boldBaseValues = NeckSizes || [];
        }
        const boldOptions = [];
        const otherOptions = [];
        for (const option of options) {
            if (boldBaseValues.includes(option.baseValue)) boldOptions.push({ ...option, bold: true });
            else otherOptions.push(option);
        }
        boldOptions.sort((a, b) => a.baseValue - b.baseValue);
        otherOptions.sort((a, b) => a.baseValue - b.baseValue);

        return [...boldOptions, ...otherOptions]
        // return reorderNeckSizes(options, boldBaseValues);
    };
    useEffect(() => {
        const fetchShirtStyles = async () => {
            try {
                let selectedShirt = null;
                if (selectedShirtStyle) {
                    const response = await get(`/all-inventories?size=1000`);
                    const data = response?.data?.rows || [];
                    selectedShirt = data.find(item => item.id === selectedShirtStyle);
                } else {
                    const stored = localStorage.getItem('shirtstyle');
                    if (stored) selectedShirt = JSON.parse(stored);
                }

                const options = getNeckOptions(AllSize?.neckSizes, selectedShirt, sizesCategory, NeckSizes);
                setNeckSizeOptions(options);
                setShirtStyleSelected(!!selectedShirt);
            } catch (error) {
                console.error(error);
                const options = getNeckOptions(AllSize?.neckSizes, null, sizesCategory, NeckSizes);
                setNeckSizeOptions(options);
                setShirtStyleSelected(false);
            }
        };

        fetchShirtStyles();
    }, [selectedShirtStyle, AllSize]);

    useEffect(() => {
        if (shirtSize) {
            setValue("shirt_size", shirtSize);
        }
        else {
            setValue("shirt_size", null);
        }

    }, [shirtSize])


    useEffect(() => {
        if (activeItem != 1) {
            setLebelCoat(CoatstyleData)
            setLebelCoatsize(CoatSizetext)
            setLabelcategoryName(categoryName)
        }
        if (activeItem != 2) {
            setLebelpant(pantstyleData)
            setLebelpantsize(Waistsize)
        }
        if (activeItem != 3) {
            setLebelShirt(shirtstyleData)
            setLebelShirtsize(shirt_size)
        }
        if (activeItem != 4) {
            setLebelVestsize(VestColor)
            setLebelVest(VeststyleData)
        }
        if (activeItem != 6) {
            setLebelShoes(Shoesstyle)
            setLebelShoessize(ShoesSize)
        }
    }, [activeItem])


    useEffect(() => {
        const savedStyle = localStorage.getItem("coatStyle") || null;
        if (savedStyle && savedStyle != "undefined") {
            const parsedStyle = JSON.parse(savedStyle);
            if (parsedStyle?.id) {
                setSelectedStyle(parsedStyle.id);
            }
        }
    }, []);

    useEffect(() => {
        if (shirtSize) {
            setValue("shirt_size", shirtSize);
        }
        else {
            setValue("shirt_size", null);
        }

    }, [shirtSize])





    const [openItems, setOpenItems] = useState({
        1: true,
        2: false,
        3: false,
    })

    const toggleItem = (id) => {
        // If clicked on currently active item, close it (set to null)
        // Otherwise, open the clicked item and close others
        setActiveItem(prevActive => prevActive === id ? null : id);
    };


    const AccordionItem = ({ id, title, children }) => {
        const [isHovered, setIsHovered] = useState(false);
        const isActive = activeItem == id;

        return (
            <div className="accordion-item">
                <button
                    className={`accordion-button ${isActive ? 'active' : ''}`}
                    onClick={() => toggleItem(id)}
                    onMouseEnter={() => setIsHovered(true)}
                    onMouseLeave={() => setIsHovered(false)}
                >
                    <span>{title}</span>
                    <span className="accordion-icon">{isActive ? <em class="icon ni ni-upword-ios"></em> : <em class="icon ni ni-downward-ios"></em>}</span>
                </button>
                {/* {isActive && <div className="accordion-content">{children}</div>} */}
                <div
                    className="accordion-content"
                    style={{ display: isActive ? 'block' : 'none' }} // ✅ crucial change
                >
                    {children}
                </div>
            </div>
        );
    };


    useEffect(() => {

        setCoatSizeValidation({});

        const storedCoatStyle = localStorage.getItem('coatStyle') || null;
        let parsedStyle = null;

        if (storedCoatStyle && storedCoatStyle !== "null") {
            try {
                const parsed = JSON.parse(storedCoatStyle);
                parsedStyle = parsed?.style;
            } catch (error) {
                console.error("Error parsing coatStyle from localStorage", error);
            }
        }

        const isValidStyle = (value) => {
            return value !== null &&
                value !== undefined &&
                value !== "null" &&
                value !== "" &&
                String(value).trim() !== "";
        };

        const hasValidSelectedStyle = isValidStyle(selectedStyle);
        const hasValidParsedStyle = isValidStyle(parsedStyle);

        if (hasValidSelectedStyle || hasValidParsedStyle) {
            setCoatSizeValidation({ required: "Coat Size is required" });
        }

    }, [selectedStyle]);



    useEffect(() => {
        if (selectedCoatSize && !categoryValidationMessage) {
            setValue("categoryValidated", "valid");
        } else {
            setValue("categoryValidated", "");
        }
    }, [selectedCoatSize, categoryValidationMessage, setValue]);

    const fetchCoatStyles = async () => {
        try {
            const response = await get(`coat-pant-styles?inventory_category_id=1&inventory_id=${selectedStyle}`);

            const data = response?.data || [];
            const sizesByCategory = {};
            data.forEach(item => {
                sizesByCategory[item.category] = item.sizes || [];
            });

            setCategorySizes(sizesByCategory);

            const formattedStyles = data.map(item => ({
                label: item.mapping?.style || item.mapping?.id?.toString(),
                value: item.mapping?.id,
                inventory_id: item.mapping?.inventory_id,
                category: item.category,
                sizes: item.sizes || [],
            }));


            // Merge all sizes for this inventory_id
            const allMatching = formattedStyles.filter(style => style.inventory_id == selectedStyle);
            const mergedSizes = Array.from(new Set(allMatching.flatMap(s => s.sizes))).sort((a, b) => a - b);


            setCoatStyleSizes(mergedSizes); // Or however you're feeding it to dropdown
            setAvailableSizesForStyle(mergedSizes);

            setCoatStyles(formattedStyles);
            validateSizeWithCategory(selectedCoatSize, categoryName, sizesByCategory, selectedStyle);

            if (selectedCoatSize && !mergedSizes.includes(Number(selectedCoatSize))) {
                const styleName = selectedStyle;
                const categoryInitial = categoryName ?
                    (categoryName.charAt(0).toUpperCase() === "E" ? "X" : categoryName.charAt(0)) :
                    '';

                setStyleValidationMessage(`Selected Coat Style ${styleName} doesn't have coat size ${selectedCoatSize}${categoryInitial}.`);
            } else {
                setStyleValidationMessage('');
            }
        } catch (err) {
            console.error("Error fetching coat styles:", err);
            if (err?.message === "Invalid or expired token" || err?.message === "Invalid Token") {
                localStorage.removeItem("token");
                navigate("/login");
            }
        }
    };


    // Function to validate if the size is available in the selected category
    const validateSizeWithCategory = (size, category, sizesByCategory = categorySizes, style = selectedStyle) => {
        if (!size || !category || !style) {
            setCategoryValidationMessage('');
            setAvailableSizes([]);
            return;
        }

        const sizeNum = Number(size);
        const categoryInitial = category.charAt(0).toUpperCase() === "E" ? "X" : category.charAt(0);
        // Find sizes available for this category
        const availableSizesForCategory = sizesByCategory[category] || [];
        setAvailableSizes(availableSizesForCategory);

        // Find the style name/label
        const selectedStyleObj = coatStyles.find(s => s.inventory_id == style);
        const styleLabel = selectedStyleObj?.label || style;


        if (availableSizesForCategory.length === 0) {
            // No sizes at all — show message
            setCategoryValidationMessage(`Coat size ${size}${categoryInitial} is not available for Coat Style ${styleLabel}.`);
        } else if (!availableSizesForCategory.includes(sizeNum)) {
            // Sizes exist, but not this one
            setCategoryValidationMessage(`Coat size ${size}${categoryInitial} is not available for Coat Style ${styleLabel}.`);
        } else {
            // Size is valid
            setCategoryValidationMessage('');
        }

    };

    // Add this effect to run validation when selections change
    useEffect(() => {
        if (selectedCoatSize && categoryName) {
            validateSizeWithCategory(selectedCoatSize, categoryName, categorySizes, selectedStyle);
        }
    }, [selectedCoatSize, categoryName, categorySizes, selectedStyle]);
    useEffect(() => {
        if (selectedStyle && selectedCoatSize && availableSizesForStyle.length > 0) {
            // Convert to number for comparison since sizes are likely stored as numbers
            const coatSizeNum = Number(selectedCoatSize);

            if (!availableSizesForStyle.includes(coatSizeNum)) {
                const categoryInitial = categoryName ?
                    (categoryName.charAt(0).toUpperCase() === "E" ? "X" : categoryName.charAt(0)) :
                    '';

                // Find the actual style label from coatStyles using selected inventory ID
                const selectedStyleObj = coatStyles.find(style => style.inventory_id == selectedStyle);
                const styleLabel = selectedStyleObj?.label || selectedStyle;

                setStyleValidationMessage(`Selected Coat Style ${styleLabel} doesn't have coat size ${selectedCoatSize}${categoryInitial}.`);
            } else {
                setStyleValidationMessage('');
            }
        } else {
            setStyleValidationMessage('');
        }
    }, [selectedCoatSize, availableSizesForStyle, categoryName, selectedStyle, coatStyles]);

    useEffect(() => {
        if (selectedStyle) {
            fetchCoatStyles();
        } else {
            // Clear coatStyleSizes when coat style is deselected
            setCoatStyleSizes([]);
        }
    }, [selectedStyle]);


    const fetchPantStyles = async () => {
        try {
            const response = await get(`coat-pant-styles?inventory_category_id=2&inventory_id=${selectedPantStyle}`);

            const data = response?.data || [];

            const formattedStyles = data.map(item => {
                const styleId = item.mapping?.id;
                const style = item.mapping?.style;
                const rawSizes = item.sizes || [];

                // Display sizes exactly as they come from the API
                // If API returns [18, 19], it will be shown as "18-19"
                // const displaySizes = rawSizes.length > 0 ? [rawSizes.join("/")] : [];


                return {
                    label: style || styleId?.toString(),
                    value: styleId,
                    inventory_id: item.mapping?.inventory_id,
                    sizes: rawSizes,
                    category: item.category, // "Boys" or "Short"
                    updatedAt: item.mapping?.updatedAt
                        ? new Date(item.mapping.updatedAt).getTime()
                        : 0,
                };
            });


            // Merge all sizes for this inventory_id
            const allMatching = formattedStyles.filter(style => style.inventory_id == selectedPantStyle);
            const mergedSizes = Array.from(new Set(allMatching.flatMap(s => s.sizes)));

            if (mergedSizes.length) {
                setPantStyleSizes({ waistSizes: mergedSizes });
            } else {
                // Use AllSize as fallback when no specific sizes found
                setPantStyleSizes({ waistSizes: AllSize?.waistSizes || [] });
            }

            const mappingsByCategory = {};
            data.forEach(item => {
                const category = item.category || 'Unknown';
                // Always overwrite with the latest (last) item for this category
                mappingsByCategory[category] = {
                    style: item.mapping?.style,
                    sizes: item.sizes || [],
                    category: category
                };
            });
            setCategoryMappings(mappingsByCategory);
            setPantStyles(formattedStyles);
        } catch (err) {
            setPantStyleSizes({ waistSizes: AllSize?.waistSizes || [] });
            setPantStyles([]); // clear list
            if (err?.message === "Invalid or expired token" || err?.message === "Invalid Token") {
                localStorage.removeItem("token");
                navigate("/login");
            }
            if (err?.message === "Invalid or expired token" || err?.message === "Invalid Token") {
                localStorage.removeItem("token");
                navigate("/login");
            }
        }
    };


    const validatePantSize = (selectedSize) => {
        if (!selectedSize || Object.keys(categoryMappings).length === 0) {
            setPantValidationMessage('');
            return true;
        }

        const sizeNum = Number(selectedSize);
        let foundInAnyCategory = false;
        let notAvailableCategory = null;
        let notAvailableStyle = null;

        // Check in which categories the size is available/not available
        Object.keys(categoryMappings).forEach(category => {
            const mapping = categoryMappings[category];
            const isAvailable = mapping.sizes.includes(sizeNum);

            if (isAvailable) {
                // Size is available in at least one category
                foundInAnyCategory = true;
            } else {
                // Track first unavailable category for message
                if (!notAvailableCategory) {
                    notAvailableCategory = category;
                    notAvailableStyle = mapping.style;
                }
            }
        });

        // Only show error if size is NOT available in ANY category
        if (!foundInAnyCategory && notAvailableCategory) {
            setPantValidationMessage(
                `Pant size ${selectedSize} is not available for Pant Style ${notAvailableStyle}.`
            );
            return false;
        } else {
            setPantValidationMessage('');
            return true;
        }
    };
    // Trigger API when pant style changes
    useEffect(() => {
        if (selectedPantStyle) {
            localStorage.setItem('selectedPantStyle', selectedPantStyle);

            fetchPantStyles();
        } else {
            // Clear data correctly (set as object with empty waistSizes)
            setPantStyleSizes({ waistSizes: AllSize?.waistSizes || [] });
            setPantValidationMessage('');
        }
    }, [selectedPantStyle, AllSize]);

    useEffect(() => {
        // On component mount, check if we have a saved selection
        const savedPantStyle = localStorage.getItem('selectedPantStyle') || null;
        const savedWaist = localStorage.getItem('savedWaist') || null;
        const savedHip = localStorage.getItem('savedHip') || null;
        const savedOutseam = localStorage.getItem('savedOutseam') || null;
        if (savedPantStyle && !selectedPantStyle) {
            // Restore the selected pant style from localStorage
            setSelectedPantStyle(savedPantStyle);
        }
        if (savedWaist) setValue("Waist", savedWaist);
        if (savedHip) setValue("hip", savedHip);
        if (savedOutseam) setValue("outseam", savedOutseam);
    }, []);

    useEffect(() => {
        const fetchBoysCoatSizeCategories = async () => {
            // Convert height to inches
            const computedHeightInInches = typeof selectedHeight === 'string' && selectedHeight.includes("'")
                ? convertHeightToInches(selectedHeight)
                : selectedHeight;

            // First, fetch all available categories to display
            try {
                let allCategoriesApi = `all-size-chart-categories`;
                let allCategoriesResponse = await get(allCategoriesApi);

                if (allCategoriesResponse?.status === true) {
                    setAllSizes(allCategoriesResponse.data.filter(
                        category => category.size_charts && category.size_charts.length > 0
                    ));
                }

                // If height < 60 AND coatSize exists (for Boys only), fetch matched categories
                if (computedHeightInInches < 60 && initialValues.coatSize && initialValues.gender === "Boys") {

                    let coatSizeApi = `all-size-chart-categories?coatSize=${initialValues.coatSize}`;
                    let coatSizeResponse = await get(coatSizeApi);

                    if (coatSizeResponse?.status === true) {

                        const validCategories = coatSizeResponse.data.filter(
                            category => category.size_charts && category.size_charts.length > 0
                        );

                        if (validCategories.length > 0) {
                            setMatchedItems(validCategories); // Update matched items for Boys
                        }
                    }
                }
            } catch (err) {
                console.error("Error fetching categories:", err);
            }
        };

        fetchBoysCoatSizeCategories();
    }, [selectedHeight, initialValues.coatSize, initialValues.gender]);

    useEffect(() => {
        setPantStyleSelected(!!watch("Pant")); // Using watch from react-hook-form
        if (!watch("Pant")) {
            // Reset all pant-related fields when Pant Style is deselected
            setValue('Waist', '');
            setValue('hip', '');
            setValue('outseam', '');
            setValue('belt', '');
            clearErrors(['Waist', 'hip', 'outseam', 'belt']);
            setSizeRecommendationMsg("");
            localStorage.removeItem('pantSizeRecommendationMsg');
        }
    }, [watch("Pant"), setValue, clearErrors]);



    useEffect(() => {
        const fetchSizeRecommendation = async () => {
            // Reset recommendation message and category at the beginning of each run
            setRecommendationMessage('');
            setRecommendedCategory(null);
            setRecommendedCategoryDisplay('');

            // Validate inputs - exit early if required fields are missing
            if (!selectedHeight || selectedHeight === "Unknown" || !selectedCoatSize) {
                return;
            }

            // Get unique coat sizes from the sizes array
            const uniqueCoatSizes = sizes
                .filter(category => category.size_charts.length > 0)
                .flatMap(category => category.size_charts.map(size => size.coatSize));

            // Exit if the coat size is not highlighted (not in uniqueCoatSizes)
            if (!uniqueCoatSizes.includes(selectedCoatSize)) {
                return; // Don't display recommendation for non-highlighted coat sizes
            }

            try {
                // Convert height to inches if it's in feet'inches" format
                const heightInInches = typeof selectedHeight === 'string' && selectedHeight.includes("'")
                    ? convertHeightToInches(selectedHeight)
                    : selectedHeight;
                const weight = watch("Weight");
                let matchingCategories = []; // Ensure weight updates

                // Track if we're using weight or not for message display
                let usingWeightInRecommendation = true;
                // let apiCallSuccessful = false;


                // // First attempt with weight parameter if available
                // let matchingCategories = await fetchCategoriesWithParams(heightInInches, selectedCoatSize, weight);
                // apiCallSuccessful = true;
                if (weight && !isNaN(Number(weight))) {
                    matchingCategories = await fetchCategoriesWithParams(heightInInches, selectedCoatSize, weight);
                    if (matchingCategories.length > 0) {
                        usingWeightInRecommendation = true;
                    }
                }

                // If no matching categories found and weight was provided, try again without weight
                if (matchingCategories.length === 0 && weight && !isNaN(Number(weight))) {
                    matchingCategories = await fetchCategoriesWithParams(heightInInches, selectedCoatSize, null);
                    // Set flag to not use weight in message when we had to retry without weight
                    usingWeightInRecommendation = false;
                }

                // Only proceed if we have successful API response
                // if (!apiCallSuccessful) {
                //     return;
                // }

                // Process matching categories if any found
                if (matchingCategories.length > 0) {
                    // Get the first matching category
                    const recommendedCategory = matchingCategories[0];

                    // Replace category name if it starts with "E"
                    if (recommendedCategory.name && recommendedCategory.name.charAt(0).toUpperCase() === 'E') {
                        recommendedCategory.name = 'X';
                    }

                    // Safety check for recommendedCategory.name
                    if (!recommendedCategory.name) {
                        return;
                    }

                    // Check if the recommended category matches the already selected category
                    const isRecommendedCategoryAlreadySelected =
                        recommendedCategory.name === categoryName;
                    const isWeightValid = weight && !isNaN(Number(weight)) && weight !== "";
                    const shouldShowNonBoldMessage = isWeightValid && selectedHeight && selectedHeight !== "Unknown";

                    // Only set recommendation message and category if not already selected
                    // if (!isRecommendedCategoryAlreadySelected) {
                    //     setRecommendedCategory(recommendedCategory);
                    if (!isRecommendedCategoryAlreadySelected && (!nonBoldMessage || nonBoldMessage.trim() === '') &&
                        !shouldShowNonBoldMessage) {
                        // Clear any existing messages before setting new ones
                        setRecommendationMessage('');
                        setRecommendedCategory(null);

                        // Small delay to ensure state is cleared
                        setTimeout(() => {
                            if (!nonBoldMessage || nonBoldMessage.trim() === '') {
                                setRecommendedCategory(recommendedCategory);

                                // Create recommendation message
                                const categoryInitial = recommendedCategory.name
                                    ? recommendedCategory.name.charAt(0).toUpperCase()
                                    : '';

                                // const weightSpecified = weight && !isNaN(Number(weight)) && usingWeightInRecommendation;
                                setCategory(categoryInitial);
                                // Only set the message once
                                const recommendationMsg =
                                    `<span style="font-size: 24px;">⚠️</span> Recommended Coat Size: ${selectedCoatSize}${categoryInitial} for Height: ${convertInchesToFeetInches(heightInInches)}` +
                                    (usingWeightInRecommendation && weight ? `, Weight: ${weight} ` : ' ');

                                setRecommendationMessage(recommendationMsg);
                            }
                        }, 50);
                    }
                } else {
                    // Clear any previous recommendations if no matches found
                    // if (!recommendationMessage) {
                    setRecommendedCategory(null);
                    setRecommendedCategoryDisplay('');
                    setRecommendationMessage('');
                    // }
                }
            } catch (err) {
                // if (!recommendationMessage) {
                setRecommendationMessage('Error fetching size recommendations');
                setRecommendedCategory(null);
                setRecommendedCategoryDisplay('');
                // }
            }
        };

        // Helper function to fetch categories with specified parameters
        const fetchCategoriesWithParams = async (heightInInches, coatSize, weight) => {
            try {
                // Construct the API URL
                const apiParams = new URLSearchParams();
                apiParams.append('height', heightInInches);
                apiParams.append('coatSize', coatSize);

                // Only add weight if it's provided and valid
                if (weight && !isNaN(Number(weight))) {
                    apiParams.append('weight', weight);
                }

                const api = `all-size-chart-categories?${apiParams.toString()}`;
                const response = await get(api);

                if (response?.status === true && response.data.length > 0) {
                    // Filter categories that match the criteria
                    return response.data.filter(category =>
                        category.size_charts &&
                        category.size_charts.some(chart =>
                            chart.coatSize === coatSize &&
                            (!chart.minHeight || heightInInches >= chart.minHeight) &&
                            (!chart.maxHeight || heightInInches <= chart.maxHeight) &&
                            // Only check weight if it's provided and valid
                            (
                                weight && !isNaN(Number(weight)) ?
                                    (!chart.minWeight || Number(weight) >= chart.minWeight) &&
                                    (!chart.maxWeight || Number(weight) <= chart.maxWeight)
                                    : true
                            )
                        )
                    );
                }
                return [];
            } catch (err) {
                console.error('Error in fetchCategoriesWithParams:', err);
                return [];
            }
        };

        const convertInchesToFeetInches = (inches) => {
            const feet = Math.floor(inches / 12);
            const remainingInches = inches % 12;
            return `${feet}'${remainingInches}"`;
        };

        // Use a debounced version of the fetch function to prevent rapid multiple calls
        const debouncedFetch = debounce(fetchSizeRecommendation, 300);
        debouncedFetch();

        // Cleanup function to cancel any pending debounced calls when dependencies change
        return () => {
            debouncedFetch.cancel();
        };
    }, [selectedHeight, selectedCoatSize, watch, categoryName, MatchedItems, initialValues]);

    // Debounce function to prevent multiple rapid executions
    function debounce(func, wait) {
        let timeout;
        const debounced = function (...args) {
            const later = () => {
                clearTimeout(timeout);
                func.apply(this, args);
            };
            clearTimeout(timeout);
            timeout = setTimeout(later, wait);
        };

        debounced.cancel = function () {
            clearTimeout(timeout);
        };

        return debounced;
    }
    useEffect(() => {
        // Update the state based on whether Shirt Style is selected
        setShirtStyleSelected(!!shirtStyleValue);
    }, [shirtStyleValue]);


    const handleBack = () => {
        const currentValues = getValues();
        onBack(currentValues);
    };
    const ViewState = async () => {
        try {
            const api = `all-inventories?size=${1000}`;
            const response = await get(api);
            if (response?.status == true) {
                setdata(response.data?.rows);
                const colors = response.data?.rows
                    .map(item => item.shoe_color)  // extract shoe_color from each item
                    .filter(color => color && color.trim() !== ""); // remove null/empty

                // Remove duplicates by converting to Set and back to array
                const uniqueColors = [...new Set(colors)];

                setShoeColors(uniqueColors);
            }
        } catch (err) {
            if (err?.message == "Invalid or expired token" || err?.message == "Invalid Token") {
                localStorage.removeItem('token');
                navigate('/login');
            }
        } finally {
        }
    };
    useEffect(() => {
        ViewState();

    }, []);

    const handleHeightChange = (event) => {
        setSelectedHeight(event.target.value); // Update state with selected height
    };



    const Allsize = async () => {
        try {
            const api = `all-size-charts`;
            const response = await get(api);
            localStorage.setItem("allSize", JSON.stringify(response?.data));

            setAllSize(response?.data)

        }
        catch (err) {
            if (err?.message == "Invalid or expired token" || err?.message == "Invalid Token") {
                localStorage.removeItem('token');
                navigate('/login');
            }
        }

    }
    useEffect(() => {
        const cached = localStorage.getItem("allSize");
        if (cached) {
            setAllSize(JSON.parse(cached));
        }
        Allsize()
    }, [])
    useEffect(() => {
        setDebouncedWeight(debouncedWeightValue);
    }, [debouncedWeightValue]);



    const size = async () => {
        try {
            const heightInInches = typeof selectedHeight === 'string' && selectedHeight.includes("'")
                ? convertHeightToInches(selectedHeight)
                : selectedHeight;
            let weightValue = watch("Weight");

            // First API call with both height and weight
            let api = heightInInches < 60 // Less than 5' (60 inches)
                ? `all-size-chart-categories?name=Boys&height=${initialValues.Height}&weight=${debouncedWeight}`
                : `all-size-chart-categories?name=Short,Regular,Long,Extra Long&height=${heightInInches}&weight=${debouncedWeight}`;

            let response = await get(api);

            if (response?.status == true) {
                // Filter out categories with empty size charts
                const filteredCategories = response.data.filter(
                    category => category.size_charts && category.size_charts.length > 0
                );

                if (!filteredCategories.find(cat => cat.name === originalCategory)) {
                    setOriginalCategory(filteredCategories[0]?.name || null);
                }


                if (!filteredCategories || filteredCategories.length === 0) {

                    // Removing weight parameter from API call
                    api = heightInInches < 60
                        ? `all-size-chart-categories?name=Boys&height=${initialValues.Height}`
                        : `all-size-chart-categories?name=Short,Regular,Long,Extra Long&height=${heightInInches}`;

                    response = await get(api);

                    if (response?.status == true) {
                        const newFilteredCategories = response.data.filter(
                            category => category.size_charts && category.size_charts.length > 0
                        );

                        if (newFilteredCategories.length > 0 && !originalCategory) {
                            setOriginalCategory(newFilteredCategories[0].name);
                        }
                        setsizes(response.data);
                        setMatchedItems(newFilteredCategories);
                    }
                } else {
                    // Original processing if filteredCategories has data
                    setsizes(response.data);
                    setMatchedItems(filteredCategories);


                }

                response.data
                    .filter(category => category.size_charts.length > 0)
                    .forEach(category => {
                        setcoattype(category.name);
                        setuniqcoat(category.size_charts)
                    });

                // Find the first valid size chart ID
                let idToStore = null;
                for (const item of response.data) {
                    if (item.size_charts && item.size_charts.length > 0) {
                        idToStore = item.id;
                        break; // Exit the loop once we find the first matching object
                    }
                }

                setSizeid(idToStore);
                setStoprender(true);
                dispatch(setSize(idToStore));
                setValue("size_chart_category_id", idToStore);
                setsizefilterid(idToStore);

                if (response?.data.length > 0) {
                    // Find the first category that has size_charts with data
                    const categoryWithCharts = response.data.find(category =>
                        category.size_charts && category.size_charts.length > 0
                    );

                    if (categoryWithCharts && categoryWithCharts.size_charts.length > 0) {
                        const chart = categoryWithCharts.size_charts[0]; // Use the first chart from the category that has data

                        // Waist Sizes
                        if (chart.minWaist && chart.maxWaist) {
                            const sizes = [];
                            for (let i = parseInt(chart.minWaist); i <= parseInt(chart.maxWaist); i++) {
                                sizes.push(i);
                            }
                            setWaistSizes(sizes);
                        }

                        // Hip Sizes
                        if (chart.minHip && chart.maxHip) {
                            const sizes = [];
                            for (let i = parseInt(chart.minHip); i <= parseInt(chart.maxHip); i++) {
                                sizes.push(i);
                            }
                            setHipSizes(sizes);
                        }

                        // Outseam Sizes
                        if (chart.minOutseam && chart.maxOutseam) {
                            const sizes = [];
                            for (let i = parseInt(chart.minOutseam); i <= parseInt(chart.maxOutseam); i++) {
                                sizes.push(i);
                            }
                            setoutseamSizes(sizes);
                        }

                        // Insleeve/Shirt Sleeve Sizes
                        if (chart.minShirtSleeve && chart.maxShirtSleeve) {
                            const sizes = [];
                            for (let i = parseInt(chart.minShirtSleeve); i <= parseInt(chart.maxShirtSleeve); i++) {
                                sizes.push(i);
                            }
                            setInsleeveSizes(sizes);
                        }

                        // Shoe Sizes
                        if (chart.minShoe && chart.maxShoe) {
                            const sizes = [];
                            for (let i = parseInt(chart.minShoe); i <= parseInt(chart.maxShoe); i++) {
                                sizes.push(i);
                            }
                            setshoesSizes(sizes);
                        }

                        // Neck Sizes
                        if (chart.minNeck && chart.maxNeck) {
                            const sizes = [];
                            for (let i = parseInt(chart.minNeck); i <= parseInt(chart.maxNeck); i++) {
                                sizes.push(i);
                            }
                            setNeckSizes(sizes);
                        }
                    } else {
                        // No categories with size charts found - clear bold sizes
                        setWaistSizes([]);
                        setHipSizes([]);
                        setoutseamSizes([]);
                        setInsleeveSizes([]);
                        setshoesSizes([]);
                        setNeckSizes([]);
                    }
                }
            }
            if (response?.status == true && response.data.length > 0) {
                let validId = null;

                for (const item of response.data) {
                    if (item.size_charts && item.size_charts.length > 0) {
                        validId = item.id;
                        break;
                    }
                }

                if (validId) {
                    if (!isUserSelectedCategory && !localStorage.getItem('isCategorySelected')) {
                        setSizeid(validId);
                        setValue("size_chart_category_id", validId);
                        dispatch(setSize(validId));
                    }
                    // localStorage.setItem('size', validId);
                }
            }
        } catch (err) {
            if (err?.message == "Invalid or expired token" || err?.message == "Invalid Token") {
                localStorage.removeItem('token');
                navigate('/login');
            }
            console.error('Error:', err);
        } finally {
        }
    };
    useEffect(() => {
        const height = selectedHeight || initialValues?.Height;
        const weight = watch("Weight");

        if (height) {
            // Check if height is a string with feet/inches format or just inches
            let heightInInches;
            if (typeof height === 'string' && height.includes("'")) {
                heightInInches = convertHeightToInches(height);
            } else {
                heightInInches = parseInt(height, 10);
            }

            // If height is less than 5'1" (61 inches), select Boys
            // Otherwise select Men
            if (heightInInches < 61) {
                setOrderForState("Boys");
                setValue("order_for", "Boys");
            } else {
                setOrderForState("Men");
                setValue("order_for", "Men");
            }

            size();
        }
    }, [selectedHeight, initialValues?.Height, debouncedWeight]);


    const convertHeightToInches = (heightString) => {
        const [feet, inches] = heightString.split("'").map(part =>
            parseInt(part.replace(/['']/g, ''), 10)
        );
        return (feet * 12) + (inches || 0);
    };

    useEffect(() => {
        const height = selectedHeight || initialValues?.Height;
        const weight = watch("Weight");

        if (height) {
            size();
        }

    }, [selectedHeight, initialValues?.Height, debouncedWeight]);


    const category1Data = data?.filter((item) => item.category_id === 1);
    const pants = data?.filter((item) => item.category_id === 2);
    const Shirt = data?.filter((item) => item.category_id === 3);
    const Vest = data?.filter((item) => item.category_id === 4);
    const Tie = data?.filter((item) => item.category_id === 5);
    const Shoes = data?.filter((item) => item.category_id === 7);

    const Pocket = data?.filter((item) => item.category_id === 8);
    const Jewelry = data?.filter((item) => item.category_id === 9);


    const heightOptions = [];
    for (let feet = 3; feet <= 6; feet++) {
        for (let inches = 1; inches <= 11; inches++) {
            const totalInches = (feet * 12) + inches; // Convert to total inches
            heightOptions.push({
                display: `${feet}'${inches}''`, // Display format
                value: totalInches // Value in inches
            });
        }
    }

    const weightValue = watch("Weight"); // Ensure weight updates

    useEffect(() => {
        if (!categoryName || !selectedCoatSize || !selectedHeight || selectedHeight === "Unknown") {

            setNonBoldMessage("");
            // Clear message if essential values are missing
            return;
        }

        // Convert height to feet & inches format
        const feet = Math.floor(selectedHeight / 12);
        const inches = selectedHeight % 12;
        const formattedHeight = `${feet}'${inches}"`;

        let categoryInitial = "";
        const categoryToUse = originalCategory || categoryName;

        if (categoryToUse) {
            // For Extra Long, use XL, otherwise use first letter
            if (categoryToUse.startsWith("Extra")) {
                categoryInitial = "X";
            } else {
                categoryInitial = categoryToUse.charAt(0);
            }
        }

        const uniqueCoatSizes = sizes
            .filter(category => category.size_charts.length > 0)
            .flatMap(category => category.size_charts.map(size => size.coatSize));
        if (uniqueCoatSizes.includes(selectedCoatSize)) {
            setNonBoldMessage("");
            return;
        }

        const isWeightValid = weightValue !== null && weightValue !== undefined && !isNaN(weightValue) && weightValue !== "";
        // const weightText = isWeightValid ? ` and weight ${weightValue}` : '';

        // Find all coat sizes that match the height range
        const validSizeCharts = sizes
            .flatMap(category => category.size_charts)
            .filter(size =>
                size.minHeight !== null &&
                size.maxHeight !== null &&
                selectedHeight >= size.minHeight &&
                selectedHeight <= size.maxHeight
            );
        // Additional check to see if weight is within the range for any coat size
        let isWeightInRange = false;
        if (isWeightValid) {
            isWeightInRange = validSizeCharts.some(chart =>
                (!chart.minWeight || Number(weightValue) >= chart.minWeight) &&
                (!chart.maxWeight || Number(weightValue) <= chart.maxWeight)
            );
        }

        // Only include weight in the message if it's valid AND in range
        const weightText = (isWeightValid && isWeightInRange) ? `, Weight: ${weightValue}` : '';


        // Find the selected coat size chart details
        const styleAvailableSizes = availableSizesForStyle.map(size => Number(size));


        if (validSizeCharts.length === 0) {
            // If no matching size chart, show the range of available coat sizes
            const allSizes = sizes
                .flatMap(category => category.size_charts.map(size => size.coatSize))
                .filter(size => !isNaN(parseInt(size)))
                .map(size => parseInt(size));

            if (allSizes.length > 0) {
                const minSize = Math.min(...allSizes);
                const maxSize = Math.max(...allSizes);



                if (minSize === maxSize) {
                    setNonBoldMessage(`<span style="font-size: 24px;">⚠️</span> Recommended Coat Size ${minSize}${categoryInitial} for height ${formattedHeight}${weightText}`);
                } else {
                    setNonBoldMessage(`<span style="font-size: 24px;">⚠️</span> Recommended Coat Size ${minSize}${categoryInitial}  to ${maxSize}${categoryInitial}  for height ${formattedHeight}${weightText}`);
                }
            }
            return;
        }

        const selectedSizeChart = validSizeCharts.find(size => size.coatSize === selectedCoatSize);

        if (!selectedSizeChart) {
            // If selected coat size is not found, recommend the full range of valid coat sizes
            const availableSizes = validSizeCharts
                .map(size => size.coatSize)
                .filter(size => !isNaN(parseInt(size)))
                .map(size => parseInt(size))
                .sort((a, b) => a - b);

            if (availableSizes.length > 0) {
                const minAvailableSize = availableSizes[0];
                const maxAvailableSize = availableSizes[availableSizes.length - 1];
                if (minAvailableSize === maxAvailableSize) {
                    setNonBoldMessage(`<span style="font-size: 24px;">⚠️</span> Recommended Coat Size ${minAvailableSize}${categoryInitial} for height ${formattedHeight}${weightText}`);
                } else {
                    // setNonBoldMessage(`<span style="font-size: 24px;">⚠️</span> Recommended Coat Size ${minAvailableSize}${categoryInitial}  to ${maxAvailableSize}${categoryInitial}   for height ${formattedHeight}${weightText}`);
                    setNonBoldMessage(`<span style="font-size: 24px;">⚠️</span> Recommended Category ${categoryToUse}   for height ${formattedHeight}${weightText}`);

                }
            }
        }



    }, [categoryName, selectedHeight, weightValue, sizes]); // Ensure reactivity


    useEffect(() => {
        const savedCoatSize = localStorage.getItem('selectedCoatSize') || null;
        const isCoatSizeSelected = localStorage.getItem('isCoatSizeSelected') === 'true';
        const savedStyle = localStorage.getItem('coatStyle') || null;
        const savedCategoryName = localStorage.getItem('selectedCategoryName') || null;
        const isCategorySelected = localStorage.getItem('isCategorySelected') === 'true';
        const savedRecommendationMessage = localStorage.getItem('recommendationMessage') || null;
        const savedNonBoldMessage = localStorage.getItem('nonBoldMessage') || null;


        // ✅ CoatStyle always restore
        if (savedStyle) {
            const parsedStyle = JSON.parse(savedStyle);
            setCoatstyle(parsedStyle);
            setValue("coatinventory_id", parsedStyle.id);
            setSelectedCoatStyleForPants(parsedStyle.style)
        }

        // ✅ Only restore coat size if user already selected earlier
        if (savedCoatSize && isCoatSizeSelected) {
            setSelectedCoatSize(savedCoatSize);
            setcoat(savedCoatSize);
            setValue("CoatSize", savedCoatSize);
            setValue("coatsize_chart_id", savedCoatSize);
            setCoatid(savedCoatSize);
        }
        else if (!savedCoatSize && initialValues?.CoatSize) {
            const coatSizeValue = initialValues.CoatSize;
            setSelectedCoatSize(coatSizeValue);
            setcoat(coatSizeValue);
            setValue("CoatSize", coatSizeValue);
            setValue("coatsize_chart_id", coatSizeValue);
            setCoatid(coatSizeValue);

            // Set localStorage for future navigation
            localStorage.setItem('selectedCoatSize', coatSizeValue);
            localStorage.setItem('isCoatSizeSelected', 'true');
        }
        if (savedCategoryName && isCategorySelected) {
            setCategoryName(savedCategoryName); // ✅ Only restore if user selected before
            setIsUserSelectedCategory(true);
        } else if (!savedCategoryName && isCategorySelected) {
            localStorage.removeItem('isCategorySelected');
            setIsUserSelectedCategory(false);
        } else if (initialValues?.CoatSize && !categoryName) {
            // For new members, don't set any category
            setCategoryName('');
            setIsUserSelectedCategory(false);
        }
        if (savedRecommendationMessage) {
            setRecommendationMessage(savedRecommendationMessage);
        }

        if (savedNonBoldMessage) {
            setNonBoldMessage(savedNonBoldMessage);
        }

        return () => {
            if (selectedCoatSize) {
                if (recommendationMessage) {
                    localStorage.setItem('recommendationMessage', recommendationMessage);
                }
                if (nonBoldMessage) {
                    localStorage.setItem('nonBoldMessage', nonBoldMessage);
                }
            } else {
                localStorage.removeItem('recommendationMessage');
                localStorage.removeItem('nonBoldMessage');
            }
        };
    }, []);

    useEffect(() => {
        if (sizeid && categoryName) {
            const isAddForm = !initialValues?.CoatSize;

            if (categoryName === "Boys" && !isUserSelectedInsleeve) {
                updateInsleeveDefault();
            }
            // For other categories, only update if not initial load
            else if (isAddForm || !isInitialLoad) {
                updateInsleeveDefault();
            }
        }
    }, [sizeid, categoryName, coatid]);

    // Add useEffect to mark initial load as complete after first render
    useEffect(() => {
        // Mark initial load as complete after component has mounted and data is loaded
        if (coatid && categoryName) {
            const timer = setTimeout(() => {
                setIsInitialLoad(false);
            }, 500); // Small delay to ensure initial values are set

            return () => clearTimeout(timer);
        }
    }, [coatid, categoryName]);

    // Add this new function to update insleeve default
    const updateInsleeveDefault = () => {
        // Check if user has manually selected a value


        let defaultValue = "";

        // Determine default value based on category name
        switch (categoryName) {
            case "Short":
                defaultValue = "16";
                break;
            case "Long":
                defaultValue = "18";
                break;
            case "Extra Long":
                defaultValue = "19";
                break;
            case "Regular":
                defaultValue = "17";
                break;
            default:
                // If categoryName doesn't match, check coatid
                switch (coatid) {
                    case "3":
                        defaultValue = "9";
                        break;
                    case "4":
                        defaultValue = "10";
                        break;
                    case "6":
                        defaultValue = "11";
                        break;
                    case "8":
                        defaultValue = "12.5";
                        break;
                    case "10":
                        defaultValue = "13";
                        break;
                    case "12":
                        defaultValue = "14";
                        break;
                    case "14":
                        defaultValue = "15";
                        break;
                    case "16":
                        defaultValue = "16";
                        break;
                    case "18":
                        defaultValue = "16.5";
                        break;
                    default:
                        defaultValue = "";
                        break;
                }
                break;
        }

        if (defaultValue) {
            setdefaultsize(defaultValue);
            setValue("Insleeve", defaultValue);
        }
    };

    useEffect(() => {
        if (coatid) {
            sizeChartCategory();
        }
    }, [coatid]);



    const sizeChartCategory = async () => {

        try {
            const api = `view-size-chart-category/${sizeid}?coatSize=${coatid}`;
            const response = await get(api);

            if (response?.status == true) {

                const storedCategoryName = localStorage.getItem('selectedCategoryName') || null;
                const isCategorySelected = localStorage.getItem('isCategorySelected') === 'true';


                // Priority: Manual selection > Auto-selection
                if (isCategorySelected && storedCategoryName) {
                    setCategoryName(storedCategoryName);

                }
                else if (response.data?.name && !isUserSelectedCategory && !storedCategoryName) {
                    setCategoryName(response.data.name);
                    localStorage.setItem('selectedCategoryName', response.data.name);

                    const isAddForm = !initialValues?.CoatSize;
                    if (isAddForm && !getValues("Insleeve") && !isUserSelectedInsleeve && response.data.name !== "Boys") {
                        updateInsleeveDefault();
                    }

                    // Auto-selection के लिए isCategorySelected को 'true' मत करो
                }

                setsizesCategory(response.data?.size_charts);

                FuncForNotVAlid(response.data.name)
                if (response.data?.name == "Boys") {

                }
                else {

                }
                setValue("coat_size_chart_id", response?.data.size_charts[0].id);

                if (!getValues("size_chart_category_id")) {
                    setValue("size_chart_category_id", response?.data.size_charts[0].id);
                }

                if (response?.data.size_charts.length > 0) {
                    const minWaist = parseInt(response?.data.size_charts[0].minWaist);
                    const maxWaist = parseInt(response?.data.size_charts[0].maxWaist);
                    const sizes = [];
                    for (let i = minWaist; i <= maxWaist; i++) {
                        sizes.push(i);
                    }

                    setWaistSizes(sizes);

                }
                if (response?.data.size_charts.length > 0) {
                    const minNeck = parseInt(response?.data.size_charts[0].minNeck);
                    const maxNeck = parseInt(response?.data.size_charts[0].maxNeck);
                    const sizes = [];
                    for (let i = minNeck; i <= maxNeck; i++) {
                        sizes.push(i);
                    }
                    setNeckSizes(sizes);

                }
                if (response?.data.size_charts.length > 0) {
                    const minShirtSleeve = parseInt(response?.data.size_charts[0].minShirtSleeve);
                    const maxShirtSleeve = parseInt(response?.data.size_charts[0].maxShirtSleeve);
                    const sizes = [];
                    for (let i = minShirtSleeve; i <= maxShirtSleeve; i++) {
                        sizes.push(i);
                    }
                    setInsleeveSizes(sizes);
                }
                if (response?.data.size_charts.length > 0) {
                    const minShoe = parseInt(response?.data.size_charts[0].minShoe);
                    const maxShoe = parseInt(response?.data.size_charts[0].maxShoe);
                    const sizes = [];
                    for (let i = minShoe; i <= maxShoe; i++) {
                        sizes.push(i);
                    }
                    setshoesSizes(sizes);
                }
                if (response?.data.size_charts.length > 0) {
                    const minOutseam = parseInt(response?.data.size_charts[0].minOutseam);
                    const maxOutseam = parseInt(response?.data.size_charts[0].maxOutseam);
                    const sizes = [];
                    for (let i = minOutseam; i <= maxOutseam; i++) {
                        sizes.push(i);
                    }
                    setoutseamSizes(sizes);
                }
                // setshoesSizes
                if (response?.data.size_charts.length > 0) {
                    const minHip = parseInt(response?.data.size_charts[0].minHip);
                    const maxHip = parseInt(response?.data.size_charts[0].maxHip);
                    const sizes = [];
                    for (let i = minHip; i <= maxHip; i++) {
                        sizes.push(i);
                    }
                    setHipSizes(sizes);
                }
            }
        } catch (err) {
            setWaistSizes([]);
            setHipSizes([])
            setNeckSizes([]);
            setInsleeveSizes([])
            setshoesSizes([])
            setoutseamSizes([])
            FuncForNotVAlid()
            console.error("API Error:", err.response || err.message);

        } finally {
        }
    };

    const handlejwellaryChange = (e) => {
        const selectedStyle = Jewelry.find(item => item.style === e.target.value);
        if (selectedStyle) {
            setValue("jewelryinventory_id", selectedStyle.id);

        }

    }

    const handleTie = (e) => {
        const selectedStyle = Tie.find(item => item.style == e.target.value);
        if (selectedStyle) {
            setValue("TieInventory_id", selectedStyle.id);
        }
    }

    const handlePocket = (e) => {
        // Get the combined value from the event
        const selectedPocketString = e.target.value; // This is `${item.style} ${item.description}`

        // Find the matching pocket style in the Pocket array
        const selectedStyle = Pocket.find(item => `${item.style}` == selectedPocketString);

        if (selectedStyle) {
            // Update the form state or other logic
            setValue("PocketInventory_id", selectedStyle.id); // Set the inventory ID
            setValue("Pocket", e.target.value, { shouldValidate: true }); // Update form value
            setValue("Pocket", e.target.value, { shouldValidate: true }); // Update form value

        } else {
            console.error("Selected pocket style not found in Pocket array.");
            // Handle the case where no matching pocket style is found
        }
    };
    const handleCoatChange = async (selectedOption) => {
        // selectedOption is the entire option object, not an event

        if (selectedOption) {
            // Find the selected item from category1Data
            const selectedStyle = category1Data.find(item => item.style === selectedOption.value);
            const serializedData = JSON.stringify(selectedStyle);
            localStorage.setItem('coatStyle', serializedData);

            // Do something with the selected style
            setValue("coatinventory_id", selectedStyle.id);
            setSelectedStyle(selectedStyle.id)

            setCoatstyle(selectedStyle); // Update state with the selected style
            setSelectedCoatSize(null);
            localStorage.removeItem('coatid');
            localStorage.removeItem('selectedCoatSize');
            setSelectedCoatSize(null);
            setcoat(null);
            setValue("CoatSize", null);  // Reset form field
            setValue("coatsize_chart_id", null);
            setCategoryName('');
            setCoatid(null);
            // localStorage.removeItem('selectedCategoryName');
            setMatchedItems([]);
            setCategoryValidationMessage('');
            setIsUserSelectedCategory(false);
            setSelectedCoatStyleForPants(selectedStyle.style);
            // Clear localStorage
            localStorage.removeItem('coatid');
            localStorage.removeItem('selectedCoatSize');
            localStorage.removeItem('isCategorySelected');

            localStorage.removeItem('selectedCategoryName');
            // Fetch related data
            try {
                await Promise.all([
                    fetchCoatStyles(),
                    fetchMatchedPantStyles(selectedStyle.style)
                ]);

                // Force refresh of size categories after style change
                // This ensures categories are available for the new style
                if (allSizes && allSizes.length > 0) {
                    // Reset all size-related states to ensure fresh data
                    setMatchedItems([]);
                    setWaistSizes([]);
                    setHipSizes([]);
                    setNeckSizes([]);
                    setInsleeveSizes([]);
                    setshoesSizes([]);
                    setoutseamSizes([]);
                }
            } catch (error) {
                console.error("Error fetching style data:", error);
            }
            // setCoatstyle(selectedStyle); // Update state with the selected style

        } else {
            // Handle the case where the selection is cleared
            setCoatstyle(null); // Reset the state
            setSelectedStyle(null); // Reset the selected style ID
            setValue("coatinventory_id", ""); // Clear the form value
            localStorage.removeItem('coatStyle');
            setCoatSizeValidation({});
            setSelectedCoatSize(null);
            localStorage.removeItem('coatid');
            localStorage.removeItem('selectedCoatSize');
            setSelectedCoatSize(null);
            setcoat(null);
            setValue("CoatSize", null);
            setValue("coatsize_chart_id", "");
            setSelectedCoatStyleForPants(null);
            setCategoryName('');
            setCoatid(null);
            setMatchedItems([]);
            setIsUserSelectedCategory(false);
            localStorage.removeItem('coatid');
            localStorage.removeItem('selectedCoatSize');
            localStorage.removeItem('selectedCategoryName');
            localStorage.removeItem('isCategorySelected');

        }
    };
    const handlePaintChange = (e) => {
        // Split the combined value to extract the style
        const selectedStyleString = e.target.value; // This is `${item.style} ${item.description}`
        const selectedStyle = pants.find(item => `${item.style}` == selectedStyleString);


        if (selectedStyle) {
            setValue("Paintinventory_id", selectedStyle.id);

            // Set the inventory ID
            setPantstyle(selectedStyle); // Update state with the selected style
            const serializedData = JSON.stringify(selectedStyle);
            localStorage.setItem('pantstyle', serializedData); // Save to localStorage
            setValue("Pant", e.target.value, { shouldValidate: true }); // Update form value
            setSelectedPantStyle(selectedStyle.id);
        } else {

            localStorage.removeItem('pantstyle'); // Remove stored data
            setValue("Paintinventory_id", ""); // Clear the ID
            setPantstyle(null); // Reset state
            setValue("Pant", ""); // Update form value
            setSelectedPantStyle(null); // <-- Important
            // setPantStyleSizes({ waistSizes: AllSize?.waistSizes || [] });
            setPantStyleSizes({ waistSizes: [] });

            // Handle the case where no matching style is found
        }
    };
    const handleShirtChange = (e) => {
        // Get the combined value from the event
        const selectedShirtString = e.target.value; // This is `${item.style} ${item.description}`

        // Find the matching shirt in the shirts array
        const selectedShirt = sortedShirts.find(item => `${item.style}` == selectedShirtString);

        if (selectedShirt) {
            // Update the form state or other logic
            setValue("shirtInventory_id", selectedShirt.id); // Set the inventory ID
            const serializedData = JSON.stringify(selectedShirt);
            localStorage.setItem('shirtstyle', serializedData); // Save to localStorage
            setValue("Shirt", e.target.value, { shouldValidate: true }); // Update form value
            setSelectedShirtStyle(selectedShirt.id)
            // Recalculate neck options immediately using selectedShirt
            const options = getNeckOptions(AllSize?.neckSizes, selectedShirt, sizesCategory, NeckSizes);
            setNeckSizeOptions(options);
        } else {
            setValue("shirtInventory_id", ""); // Set the inventory ID
            setSelectedShirtStyle(null)
            localStorage.removeItem('shirtstyle'); // Save to localStorage
            setValue("Shirt", ""); // Update form value
            const options = getNeckOptions(AllSize?.neckSizes, null, sizesCategory, NeckSizes);
            setNeckSizeOptions(options);

            // Handle the case where no matching shirt is found
        }
    };
    const handleVestChange = (e) => {
        // Find the selected item from category1Data
        const selectedStyle = Vest.find(item => item.style == e.target.value) || null;
        setValue("Vest", e.target.value, { shouldValidate: true });

        if (selectedStyle) {

            // Store valid JSON in localStorage
            localStorage.setItem('Veststyle', JSON.stringify(selectedStyle));

            // Safely set value if selectedStyle is not null
            setValue("VestInventory_id", selectedStyle.id);
            setVeststyle(selectedStyle);
        } else {
            // Handle case where user clears the selection
            setValue("Vest", "");

            localStorage.removeItem('Veststyle'); // Remove stored data
            setValue("VestInventory_id", ""); // Clear the ID
            setVeststyle(null); // Reset state

        }
    };
    const handleShoes = (e) => {
        // Get the combined value from the event
        const selectedShoesString = e.target.value; // This is `${item.style} ${item.description}`

        // Find the matching shoes in the Shoes array
        const selectedStyle = Shoes.find(item => item.style == e.target.value);

        if (selectedStyle) {
            localStorage.setItem('Shoes', JSON.stringify(selectedStyle));
            setShoesstyle(selectedStyle)
            // Update the form state or other logic
            setValue("ShoesInventory_id", selectedStyle.id); // Set the inventory ID
            setValue("Shoes", e.target.value, { shouldValidate: true });
        } else {
            setShoesstyle("")
            localStorage.removeItem('Shoes'); // Remove stored data

        }
    };

    const fetchInventoryDatatwi = async () => {
        try {
            const api = `all-inventory-categories`;
            const totalData = await get(api);



        } catch (err) {
            if (err?.message == "Invalid or expired token" || err?.message == "Invalid Token") {
                localStorage.removeItem('token');
                navigate('/login');
            }


        } finally {
        }
    };
    useEffect(() => {
        fetchInventoryDatatwi()
    }, [])
    const options = category1Data.map(item => ({
        value: item.style,
        label: `${item.style} ${item.description}`
    }));

    const getHeightOptions = () => {
        // First create the base options
        const baseOptions = heightOptions.map(height => {
            const heightValue = String(height.value); // Convert to string to ensure includes() works

            // Parse the height value to get height in inches
            let heightInches = 0;

            if (heightValue === "Unknown") {
                // Handle "Unknown" case
                heightInches = 0;
            } else if (typeof heightValue === 'string' && heightValue.includes("'")) {
                // Handle format like "5'10"
                const parts = heightValue.split("'");
                const feet = parseInt(parts[0], 10) || 0;
                const inches = parseInt(parts[1], 10) || 0;
                heightInches = feet * 12 + inches;
            } else if (typeof heightValue === 'string') {
                // Try to parse as just inches if it doesn't match the expected format
                heightInches = parseInt(heightValue, 10) || 0;
            }



            return {
                value: height.value,
                label: height.display,
                // isDisabled: isDisabled
            };
        });

        // Add Unknown option which is always enabled
        return [
            { value: "Unknown", label: "Unknown", isDisabled: false },
            ...baseOptions
        ];
    };

    const coatSizeOptions = sizes
        .filter(category => category.size_charts.length > 0) // Filter out categories with no sizes
        .flatMap(category =>
            category.size_charts.map(size => ({
                value: size.coatSize, // Use coatSize as the value
                label: size.coatSize, // Use coatSize as the label
            }))
        );

    const sortedOptions = [...options].sort((a, b) => a.label.localeCompare(b.label, undefined, { numeric: true }));
    const sortedPants = [...pants].sort((a, b) =>
        a.style.localeCompare(b.style, undefined, { numeric: true })
    );
    const sortedShirts = [...Shirt].sort((a, b) =>
        a.style.localeCompare(b.style, undefined, { numeric: true })
    );
    const sortedVest = [...Vest].sort((a, b) =>
        a.style.localeCompare(b.style, undefined, { numeric: true })
    );
    const sortedTie = [...Tie].sort((a, b) =>
        a.style.localeCompare(b.style, undefined, { numeric: true })
    );
    const sortedPocketSquare = [...Pocket].sort((a, b) =>
        a.style.localeCompare(b.style, undefined, { numeric: true })
    );
    const sortedJewelry = [...Jewelry].sort((a, b) =>
        a.style.localeCompare(b.style, undefined, { numeric: true })
    );
    const sortedShoes = [...Shoes].sort((a, b) =>
        a.style.localeCompare(b.style, undefined, { numeric: true })
    );


    const customComponents = {
        DropdownIndicator: (props) => (
            <div {...props} style={{ padding: "5px", display: "flex", alignItems: "center" }}>
                <Search size={16} />
            </div>
        ),
    };
    // Add this function to your component
    const getShirtSize = (neck, sleeve) => {
        if (!neck) return "";

        const neckValue = Number(neck);

        const sleeveValue = sleeve ? Number(sleeve) : null; // Convert only if sleeve exists

        if (neckValue < 13) {
            if (neckValue >= 10 && neckValue <= 10.5) return "BXS";
            if (neckValue >= 11 && neckValue <= 11.5) return "BS";
            if (neckValue >= 12 && neckValue <= 12.5) return "BM";
            // if (neckValue >= 13 && neckValue <= 13.5) return "BL";
            return ""; // Return empty if no match
        }
        // ✅ Special case: 13 / 13.5 without sleeve = Boys' Large (BL)
        if ((neckValue === 13 || neckValue === 13.5) && !sleeveValue) {
            return "BL";
        }

        const shirtMapping = {
            13: { 30: "XS1", 32: "XS3" },
            14: { 30: "S1", 32: "S3", 34: "S5", 36: "S7" },
            15: { 30: "M1", 32: "M3", 34: "M5", 36: "M7", 38: "M9" },
            16: { 30: "L1", 32: "L3", 34: "L5", 36: "L7", 38: "L9" },
            17: { 30: "XL1", 32: "XL3", 34: "XL5", 36: "XL7", 38: "XL9" },
            18: { 30: "2XL1", 32: "2XL3", 34: "2XL5", 36: "2XL7", 38: "2XL9" },
            19: { 32: "3XL3", 34: "3XL5", 36: "3XL7", 38: "3XL9" },
            20: { 32: "4XL3", 34: "4XL5", 36: "4XL7", 38: "4XL9" },
            22: { 32: "5XL3", 34: "5XL5", 36: "5XL7", 38: "5XL9" },
            24: { 34: "6XL5", 36: "6XL7", 38: "6XL9" },
            26: { 34: "7XL5", 36: "7XL7", 38: "7XL9" }
        };




        const neckKey = Math.round(neckValue);
        // Find the closest mapping for sleeve size (floor to nearest even number)
        const sleeveKey = sleeveValue ? Math.round(sleeveValue / 2) * 2 : null;
        return shirtMapping[neckKey]?.[sleeveKey] || "";

    };
    // Add these arrays to your component, outside any functions
    const boysShoeSizes = [
        "1K", "2K", "3K", "4K", "5K", "6K", "7K", "8K", "9K", "10K", "11K", "12K", "13K", "10D", "10W", "10.5D", "10.5W", "11D", "11W", "11.5D", "11.5W",
        "12D", "12W", "13D", "13W", "14D", "14W", "15D", "15W",
        "16D", "16W", "17D", "17W", "18D", "18W"
    ];

    const ShoeSizes = [
        "1K", "2K", "3K", "4K", "5K", "6K", "8K", "9K", "10K", "11K", "12K", "13K", " 6.5D", "7D", "7.5D", "8D", "8W", "8.5D", "8.5W", "9D", "9W", "9.5D", "9.5W", "10D", "10W", "10.5D", "10.5W", "11D", "11W", "11.5D", "11.5W",
        "12D", "12W", "13D", "13W", "14D", "14W", "15D", "15W",
        "16D", "16W", "17D", "17W", "18D", "18W"
    ];


    useEffect(() => {
        // Get current values from the form
        const neckValueRaw = watch("ShirtSize");
        const sleeveValue = watch("Sleeve");

        const neckValue = neckValueRaw ? Number(neckValueRaw.split("/")[0]) : null;

        let calculatedShirtSize = isBoyOrder ? getShirtSize(neckValue, null) : getShirtSize(neckValue, sleeveValue);

        setDisableSleeve(false); // Ensure the sleeve dropdown remains enabled
        setShirtSizes(calculatedShirtSize || "");

        // Make sure we're passing a string to the reducer
        // if (calculatedShirtSize) {
        dispatch(setShirtSize(calculatedShirtSize));
        // }
    }, [watch("ShirtSize"), watch("Sleeve"), coatid, selectedHeight, initialValues.Height]);


    const isBoyOrder = useMemo(() => {
        const coatSizeValue = watch("CoatSize");

        if (!coatSizeValue) return false; // Default to Men's order if no size is selected

        // If coat size is between 3 and 18, classify as Boys
        if (coatSizeValue >= 3 && coatSizeValue <= 18) {
            return true; // Boy Order
        }

        return false; // Otherwise, it's a Men's order
    }, [watch("CoatSize")]);

    // 1. Helper function to get first enabled category
    const getFirstEnabledCategory = (matchedItems) => {
        if (!matchedItems || matchedItems.length === 0) return null;

        // Sort categories in order: Short, Regular, Long, Extra Long, Boys
        const categoryOrder = ['Short', 'Regular', 'Long', 'Extra Long', 'Boys'];

        const sortedCategories = matchedItems.sort((a, b) => {
            const aIndex = categoryOrder.indexOf(a.name);
            const bIndex = categoryOrder.indexOf(b.name);
            return aIndex - bIndex;
        });

        return sortedCategories[0];
    };
    useEffect(() => {
        if (coatid && !categoryName) {
            FuncForNotVAlid(); // यह function already handle करता है category selection
        }
    }, [coatid]);

    const FuncForNotVAlid = async () => {
        try {
            const api = `all-size-chart-categories?coatSize=${coatid}`;
            const response = await get(api);
            if (response?.status == true) {
                let matchedItems = [];
                const isCategorySelected = localStorage.getItem('isCategorySelected') === 'true';
                const storedCategoryName = localStorage.getItem('selectedCategoryName') || null;
                const storedCategoryId = localStorage.getItem('selectedCategoryId') || null;


                // Find all categories that have the selected coat size
                for (const item of response.data) {
                    if (item.size_charts && item.size_charts.length > 0) {
                        for (const sizeChart of item.size_charts) {
                            if (sizeChart.coatSize === coatid) {
                                matchedItems.push(item);
                                break;
                            }
                        }
                    }
                }

                setMatchedItems(matchedItems);

                // ✅ Category selection logic
                if (matchedItems.length > 0) {
                    let categoryToSelect = null;
                    let categoryIdToSet = null;

                    // First priority: User's manual selection (if still valid)
                    if (isCategorySelected && storedCategoryName && storedCategoryId) {
                        const userSelectedCategory = matchedItems.find(item => item.name === storedCategoryName);
                        if (userSelectedCategory) {
                            categoryToSelect = storedCategoryName;
                            categoryIdToSet = userSelectedCategory.id;
                        }
                    }
                    if (!categoryToSelect && storedCategoryName) {
                        const storedCategory = matchedItems.find(item => item.name === storedCategoryName);
                        if (storedCategory) {
                            categoryToSelect = storedCategoryName;
                            categoryIdToSet = storedCategory.id;
                        }
                    }
                    // Second priority: Auto-select first enabled category
                    if (!categoryToSelect) {
                        const firstEnabledCategory = getFirstEnabledCategory(matchedItems);
                    }

                    // Apply the selected category
                    if (categoryToSelect && categoryIdToSet) {
                        setCategoryName(categoryToSelect);
                        setValue("size_chart_category_id", categoryIdToSet);
                        dispatch(setSize(categoryIdToSet));
                        setSizeid(categoryIdToSet);
                        localStorage.setItem('selectedCategoryId', categoryIdToSet);

                    }
                } else {
                    // No categories available - clear selection
                    setCategoryName('');
                    localStorage.removeItem('selectedCategoryName');
                    localStorage.removeItem('isCategorySelected');
                }
            }
        } catch (err) {
            if (err?.message == "Invalid or expired token" || err?.message == "Invalid Token") {
                localStorage.removeItem('token');
                navigate('/login');
            }
        }
    };

    useEffect(() => {
        const neckValueRaw = watch("ShirtSize"); // Get the selected neck size
        const neckValue = neckValueRaw ? Number(neckValueRaw.split("/")[0]) : null; // Extract valid number

        const isBoyOrder = neckValue !== null && neckValue <= 13; // Boys' order condition

        const shouldAffectSleeve = isBoyOrder && neckValue < 13;

        setDisableSleeve(shouldAffectSleeve); //  Only disable for neck < 13
        setShowSleeve(!shouldAffectSleeve);
        if (shouldAffectSleeve) {
            // Clear errors for Sleeve if it's disabled
            clearErrors("Sleeve");
        }
    }, [watch("ShirtSize")]);



    // Function to generate neck sizes without duplicates
    const generateNeckSizes = (sizes) => {
        return [...new Set(sizes.map(size => Math.floor(size)))] // Remove duplicates
            .sort((a, b) => a - b) // Sort ascending
            .map(baseSize => {
                if (baseSize >= 10 && baseSize < 20) {
                    return { value: `${baseSize}/${baseSize + 0.5}`, label: `${baseSize}/${baseSize + 0.5}`, baseValue: baseSize }; // 10/10.5, 11/11.5, etc.
                } else if (baseSize >= 20 && baseSize % 2 === 0) {
                    return {
                        value: `${baseSize}/${baseSize + 1}`, label: `${baseSize}/${baseSize + 1}`, baseValue: baseSize  // Store original base number for comparison
                    }; // 20/21, 22/23, 24/25 (Skipping alternate)
                }
                return null;
            })
            .filter(option => option !== null); // Remove null values
    };

    const [neckSizeOptions, setNeckSizeOptions] = useState(
        reorderNeckSizes(generateNeckSizes(AllSize?.neckSizes || []), NeckSizes)
    );

    const sleeveSizeMapping = {
        "13/13.5": [30, 32],
        "14/14.5": [30, 32, 34, 36],
        "15/15.5": [30, 32, 34, 36, 38],
        "16/16.5": [30, 32, 34, 36, 38],
        "17/17.5": [30, 32, 34, 36, 38],
        "18/18.5": [30, 32, 34, 36, 38],
        "19/19.5": [32, 34, 36, 38],
        "20/21": [32, 34, 36, 38],
        "22/23": [32, 34, 36, 38],
        "24/25": [34, 36, 38],
        "26/27": [34, 36, 38],
    };

    const handleNeckChange = (selectedOption) => {
        setSelectedNeckSize(selectedOption ? selectedOption.value : null);
        setValue("ShirtSize", selectedOption ? selectedOption.value : ''); // Update form state
    };


    const filteredSleeveOptions = useMemo(() => {
        if (!selectedNeckSize) return [];
        // Get the current selected shirt style - extract just the style number
        const shirtValue = watch("Shirt");
        const currentShirtStyle = shirtValue ? shirtValue.split(' ')[0] : null; // Extract style number only

        // Define styles that should only show specific sleeves
        const restrictedStyles = ["606", "610", "614"];

        // Define the restricted sleeve sizes for those styles
        const restrictedSleeves = [34, 36];

        let availableSizes = [];

        // Check if current style is in restricted list
        if (currentShirtStyle && restrictedStyles.includes(currentShirtStyle)) {
            // For restricted styles, only show 34/35 and 36/37
            availableSizes = restrictedSleeves;
        } else {
            // For other styles, use the normal mapping
            availableSizes = sleeveSizeMapping[selectedNeckSize] || [];
        }

        const options = availableSizes.map(size => ({
            value: size,
            label: `${size}/${size + 1}`,
            isBold: InsleeveSizes.includes(size) || InsleeveSizes.includes(size + 1)
        }));

        // Separate bold and normal options
        const boldOptions = options.filter(option => option.isBold).sort((a, b) => a.value - b.value);
        const normalOptions = options.filter(option => !option.isBold);

        // Sort normal options: larger first, then smaller
        const largerNormals = normalOptions.filter(option =>
            boldOptions.length === 0 || option.value > Math.max(...boldOptions.map(b => b.value))
        ).sort((a, b) => a.value - b.value);

        const smallerNormals = normalOptions.filter(option =>
            boldOptions.length > 0 && option.value < Math.min(...boldOptions.map(b => b.value))
        ).sort((a, b) => b.value - a.value);

        // Combine: bold first, then larger normals, then smaller normals
        return [...boldOptions, ...largerNormals, ...smallerNormals];
    }, [selectedNeckSize, InsleeveSizes, watch("Shirt")]);

    useEffect(() => {
        // Load saved recommendation messages when component mounts
        const savedPantMsg = localStorage.getItem('pantSizeRecommendationMsg') || null;
        const savedShirtMsg = localStorage.getItem('shirtSizeRecommendationMsg') || null;
        const savedVestMsg = localStorage.getItem('vestRecommendationMsg') || null;

        if (savedPantMsg) setSizeRecommendationMsg(savedPantMsg);
        if (savedShirtMsg) setShirtSizeRecommendationMsg(savedShirtMsg);
        if (savedVestMsg) setVestRecommendationMsg(savedVestMsg);
    }, []);
    useEffect(() => {
        const waist = watch("Waist");
        const shirtSize = watch("ShirtSize");
        const selectedVestSize = watch("VestColor"); // <-- this line fixes the error
        const outseam = watch("outseam");
        const hip = watch("hip");
        const sleeve = watch("Sleeve");

        // Run checks whenever values change
        if (pantStyleSelected) {
            checkPantSizeRanges(waist, "waist" || null, "waist");
        } else if (selectedHeight && weight) {
            checkPantSizeRanges(null, "auto"); // ✅ height+weight base recommendation
        }
        if (shirtSize) {
            checkShirtSizeRanges(shirtSize, "neck");
        }

        const vestValue = selectedVestSize ? { value: selectedVestSize, label: selectedVestSize.toString() } : null;

        // Always check vest size if a vest is selected, even when coat ID changes
        if (vestValue) {
            checkVestSizeRanges(vestValue, "vest");
        }
    }, [coatid, categoryName, selectedHeight, watch("Vest"), watch("Waist"), pantStyleSelected, watch("outseam"), watch("hip"), watch("Sleeve"), watch("ShirtSize")]);


    const checkPantSizeRanges = (selectedValue, fieldType) => {
        // Clear existing message first
        setSizeRecommendationMsg("");

        // Get user input values
        const waist = Number(watch("Waist"));
        const outseam = Number(watch("outseam"));
        const hip = Number(watch("hip"));
        const weight = watch("Weight");

        // Convert height to feet & inches format
        const feet = Math.floor(selectedHeight / 12);
        const inches = selectedHeight % 12;
        const formattedHeight = `${feet}'${inches}"`;

        // Waist Validation (Only if pantStyle is selected)
        let waistWarning = "";

        if (fieldType === 'waist' && (!selectedValue || selectedValue === "")) {
            const updatedMsg = sizeRecommendationMsg
                .replace(/Recommended Waist sizes: [^,.]+,?\s?/g, "")
                .replace(/Recommended Waist: [^,.]+,?\s?/g, "")
                .trim();

            const finalMsg = updatedMsg ? `${updatedMsg}.` : "";
            setSizeRecommendationMsg(finalMsg);
            localStorage.setItem('pantSizeRecommendationMsg', finalMsg);
            // return;
        }



        if (pantStyleSelected && selectedValue && fieldType === 'waist') {
            if (selectedValue.includes('/')) {
                const splitValues = selectedValue.split('/').map(Number);

                const waistMin = sizesCategory[0]?.minWaist;
                const waistMax = sizesCategory[0]?.maxWaist;
                // const allValid = splitValues.every(val => waistSizes.includes(val));
                const anyValid = splitValues.some(val => val >= waistMin && val <= waistMax);





                if (!anyValid) {

                    if (waistMin !== null && waistMax !== null &&
                        waistMin !== undefined && waistMax !== undefined) {
                        const waistText = `${waistMin}-${waistMax}`;
                        waistWarning = `Recommended Waist sizes: ${waistText}`;

                        const msg = `<span style="font-size: 24px;">⚠️</span> ${waistWarning}`;
                        setSizeRecommendationMsg(msg);
                        localStorage.setItem('pantSizeRecommendationMsg', msg);
                    }
                    // return;
                } else {
                    setSizeRecommendationMsg("");
                    localStorage.removeItem('pantSizeRecommendationMsg');
                }

            }
        }


        // Case 1: Coat size is selected - use existing logic
        if (coatid && sizesCategory[0]) {
            const coatSize = coatid;
            const waistMin = sizesCategory[0]?.minWaist;
            const waistMax = sizesCategory[0]?.maxWaist;
            const outseamMin = sizesCategory[0]?.minOutseam;
            const outseamMax = sizesCategory[0]?.maxOutseam;
            const hipMin = sizesCategory[0]?.minHip;
            const hipMax = sizesCategory[0]?.maxHip;
            if (waistMin && waistMax) {
                setRecommendedRange({
                    waistMin, waistMax, hipMin,
                    hipMax,
                    outseamMin,
                    outseamMax,
                });
            }
            const noValidSizeData =
                [waistMin, waistMax, outseamMin, outseamMax, hipMin, hipMax].every(val => val === null || val === undefined);

            if (noValidSizeData) {
                setSizeRecommendationMsg("");
                localStorage.removeItem('pantSizeRecommendationMsg');
                return;
            }
            const isWaistOut = waist && (waist < waistMin || waist > waistMax);
            const isOutseamOut = outseam && (outseam < outseamMin || outseam > outseamMax);
            const isHipOut = hip && (hip < hipMin || hip > hipMax);

            let categoryInitial = categoryName?.charAt(0) || "";
            if (categoryName?.includes("E")) {
                categoryInitial = "X";
            }

            const previousMsg = sizeRecommendationMsg || "";
            const hasPreviousWaistWarning = pantStyleSelected && previousMsg.includes("Recommended Waist sizes");
            if (isWaistOut || isOutseamOut || isHipOut || waistWarning || hasPreviousWaistWarning) {
                let msg = `<span style="font-size: 24px;">⚠️</span> For Coat Size ${coatSize}${categoryInitial}: `;
                const parts = [];

                if (waistWarning) {
                    parts.push(waistWarning);
                }

                if (waist && isWaistOut) parts.push(`Recommended Waist: ${waistMin}-${waistMax}`);
                if (outseam && isOutseamOut) parts.push(`Recommended Outseam: ${outseamMin}-${outseamMax}`);
                if (hip && isHipOut) parts.push(`Recommended Hip: ${hipMin}-${hipMax}`);


                const finalMsg = parts.length ? msg + parts.join(", ") + "." : "";
                setSizeRecommendationMsg(finalMsg);
                localStorage.setItem('pantSizeRecommendationMsg', finalMsg);

            } else {
                setSizeRecommendationMsg("");
                localStorage.removeItem('pantSizeRecommendationMsg', "");
            }
        }
        // Case 2: No coat size but have valid height and weight
        else if (selectedHeight && weight) {
            const isWeightValid = weight !== null && weight !== undefined && !isNaN(weight) && weight !== "";


            const validSizeCharts = sizes
                .flatMap(category => category.size_charts)
                .filter(size =>
                    size.minHeight !== null &&
                    size.maxHeight !== null &&
                    selectedHeight >= size.minHeight &&
                    selectedHeight <= size.maxHeight
                );


            let isWeightInRange = false;
            if (isWeightValid) {
                isWeightInRange = validSizeCharts.some(chart =>
                    (!chart.minWeight || Number(weight) >= chart.minWeight) &&
                    (!chart.maxWeight || Number(weight) <= chart.maxWeight)
                );
            }

            if (isWeightValid && isWeightInRange && validSizeCharts.length > 0) {
                const sizeData = sizes || [];
                if (sizeData.length > 0) {
                    let foundChart = null;

                    for (const category of sizeData) {
                        if (category.size_charts && category.size_charts.length > 0) {
                            foundChart = category.size_charts[0];
                            break;
                        }
                    }


                    if (foundChart) {
                        const waistMin = foundChart.minWaist;
                        const waistMax = foundChart.maxWaist;
                        const outseamMin = foundChart.minOutseam;
                        const outseamMax = foundChart.maxOutseam;
                        const hipMin = foundChart.minHip;
                        const hipMax = foundChart.maxHip;
                        if (waistMin && waistMax && hipMin && hipMax && outseamMin &&
                            outseamMax) {
                            setRecommendedRange({
                                waistMin, waistMax, hipMin,
                                hipMax,
                                outseamMin,
                                outseamMax,
                            });
                        }
                        const isWaistOut = waist && (waist < waistMin || waist > waistMax);
                        const isOutseamOut = outseam && (outseam < outseamMin || outseam > outseamMax);
                        const isHipOut = hip && (hip < hipMin || hip > hipMax);

                        let msg = `<span style="font-size: 24px;">⚠️</span> Based on Height (${formattedHeight}) and Weight (${weight}): `;
                        const parts = [];
                        if (waistWarning) {
                            parts.push(waistWarning);
                        }

                        // Check each field independently - don't require all fields to be filled
                        if (waist && isWaistOut) parts.push(`Recommended Waist: ${waistMin}-${waistMax}`);
                        if (outseam && isOutseamOut) parts.push(`Recommended Outseam: ${outseamMin}-${outseamMax}`);
                        if (hip && isHipOut) parts.push(`Recommended Hip: ${hipMin}-${hipMax}`);

                        const finalMsg = parts.length ? msg + parts.join(", ") + "." : "";
                        setSizeRecommendationMsg(finalMsg);
                        localStorage.setItem('pantSizeRecommendationMsg', finalMsg);



                        const isAllSelected = waist && outseam && hip;

                        // Show message only if all three are selected
                        if (isAllSelected) {
                            let msg = `<span style="font-size: 24px;">⚠️</span> Based on Height (${formattedHeight}) and Weight (${weight}): `;
                            const parts = [];
                            if (waistWarning) parts.push(waistWarning);

                            if (isWaistOut) parts.push(`Recommended Waist: ${waistMin}-${waistMax}`);
                            if (isOutseamOut) parts.push(`Recommended Outseam: ${outseamMin}-${outseamMax}`);
                            if (isHipOut) parts.push(`Recommended Hip: ${hipMin}-${hipMax}`);

                            const finalMsg = parts.length ? msg + parts.join(", ") + "." : "";
                            setSizeRecommendationMsg(finalMsg);
                            localStorage.setItem('pantSizeRecommendationMsg', finalMsg);

                        } else {
                            let msg = `<span style="font-size: 24px;">⚠️</span> Based on Height (${formattedHeight}) and Weight (${weight}): `;

                            // If only one or two fields selected, show message only for those
                            const parts = [];
                            if (waistWarning) parts.push(waistWarning);

                            if (waist && isWaistOut) parts.push(` Recommended Waist: ${waistMin}-${waistMax}`);
                            if (outseam && isOutseamOut) parts.push(` Recommended Outseam:${outseamMin}-${outseamMax}`);
                            if (hip && isHipOut) parts.push(` Recommended Hip: ${hipMin}-${hipMax}`);

                            const finalMsg = parts.length ? msg + parts.join(", ") + "." : "";
                            setSizeRecommendationMsg(finalMsg);
                            localStorage.setItem('pantSizeRecommendationMsg', finalMsg);

                        }
                    }
                }

            } else {
                setSizeRecommendationMsg("");
            }
        }

    };

    useEffect(() => {
        if (selectedHeight && watch("Weight")) {
            // Trigger with null to just set the recommended range without validation
            checkPantSizeRanges(null, null);
        }
    }, [selectedHeight, watch("Weight")]);


    const checkShirtSizeRanges = (selectedValue, fieldType) => {
        setShirtSizeRecommendationMsg(""); // Clear any existing message

        const neckRaw = watch("ShirtSize");
        const sleeveRaw = watch("Sleeve");
        const neckValue = neckRaw ? Number(neckRaw.split("/")[0]) : null;
        const sleeveValue = sleeveRaw ? Number(sleeveRaw) : null;
        const weight = watch("Weight");


        // Convert height to feet & inches format
        const feet = Math.floor(selectedHeight / 12);
        const inches = selectedHeight % 12;
        const formattedHeight = `${feet}'${inches}"`;

        const isNeckProvided = neckValue !== null && neckRaw !== "";
        const isSleeveProvided = sleeveValue !== null && sleeveRaw !== "";

        const isWeightValid = weight !== null && weight !== undefined && !isNaN(weight) && weight !== "";

        const validSizeCharts = sizes
            .flatMap(category => category.size_charts)
            .filter(size =>
                size.minHeight !== null &&
                size.maxHeight !== null &&
                selectedHeight >= size.minHeight &&
                selectedHeight <= size.maxHeight
            );

        let isWeightInRange = false;
        if (isWeightValid) {
            isWeightInRange = validSizeCharts.some(chart =>
                (!chart.minWeight || Number(weight) >= chart.minWeight) &&
                (!chart.maxWeight || Number(weight) <= chart.maxWeight)
            );
        }

        const isHeightAndWeightValid = selectedHeight && isWeightValid && isWeightInRange;

        // Case 1: If coat ID exists, use existing chart logic
        if (coatid && sizesCategory[0]) {
            const neckMin = sizesCategory[0]?.minNeck;
            const neckMax = sizesCategory[0]?.maxNeck;
            const sleeveMin = sizesCategory[0]?.minShirtSleeve;
            const sleeveMax = sizesCategory[0]?.maxShirtSleeve;

            const isNeckOutOfRange = isNeckProvided && (neckValue < neckMin || neckValue > neckMax);
            const isSleeveOutOfRange = isSleeveProvided && (sleeveValue + 1 < sleeveMin || sleeveValue > sleeveMax);

            let categoryInitial = categoryName?.charAt(0) || "";
            if (categoryName?.includes("E")) {
                categoryInitial = "X";
            }
            const coatSize = coatid;

            let msg = `<span style="font-size: 24px;">⚠️</span> For Coat Size ${coatSize}${categoryInitial}: `;
            const parts = [];

            if (isNeckProvided && isNeckOutOfRange) {
                parts.push(`Recommended Neck Size: ${neckMin}-${neckMax}`);
            }

            if (isSleeveProvided && isSleeveOutOfRange) {
                parts.push(`Recommended Sleeve Length: ${sleeveMin}-${sleeveMax}`);
            }

            const finalMsg = parts.length ? msg + parts.join(", ") + "." : "";
            setShirtSizeRecommendationMsg(finalMsg);
            localStorage.setItem('shirtSizeRecommendationMsg', finalMsg);

        }

        // Case 2: No coat ID but valid height and weight
        else if (!coatid && isHeightAndWeightValid) {
            let foundChart = null;
            for (const category of sizes || []) {
                if (category.size_charts && category.size_charts.length > 0) {
                    foundChart = category.size_charts[0];
                    break;
                }
            }

            if (foundChart) {
                const neckMin = foundChart?.minNeck;
                const neckMax = foundChart?.maxNeck;
                const sleeveMin = foundChart?.minShirtSleeve;
                const sleeveMax = foundChart?.maxShirtSleeve;

                const isNeckOutOfRange = isNeckProvided && (neckValue < neckMin || neckValue > neckMax);
                const isSleeveOutOfRange = isSleeveProvided && (sleeveValue < sleeveMin || sleeveValue > sleeveMax);

                let msg = `<span style="font-size: 24px;">⚠️</span> Based on Height (${formattedHeight}) and Weight (${weight}): `;
                const parts = [];

                if (isNeckProvided && isNeckOutOfRange) {
                    parts.push(`Recommended Neck Size: ${neckMin}-${neckMax}`);
                }

                if (isSleeveProvided && isSleeveOutOfRange) {
                    parts.push(`Recommended Sleeve Length: ${sleeveMin}-${sleeveMax}`);
                }

                const finalMsg = parts.length ? msg + parts.join(", ") + "." : "";
                setShirtSizeRecommendationMsg(finalMsg);
                localStorage.setItem('shirtSizeRecommendationMsg', finalMsg);

            }
        } else {
            setShirtSizeRecommendationMsg("");
        }
    };


    const checkVestSizeRanges = (selectedValue, fieldType) => {
        // Clear any existing message
        setVestRecommendationMsg("");

        const weight = watch("Weight");
        // Convert height to feet & inches format
        const feet = Math.floor(selectedHeight / 12);
        const inches = selectedHeight % 12;
        const formattedHeight = `${feet}'${inches}"`;
        // Case 1: If coat ID exists, use standard chart logic
        if (coatid && sizesCategory[0]) {
            // Validate selected value
            if (!selectedValue || selectedValue.value === undefined) return;

            const selectedVestSize = String(selectedValue.value);
            const recommendedVest = String(sizesCategory[0]?.vestSize || "").trim();
            let categoryInitial = categoryName?.charAt(0) || "";
            if (categoryName?.includes("E")) {
                categoryInitial = "X";
            }
            const isVestOutOfRange = selectedVestSize !== recommendedVest;

            if (isVestOutOfRange) {

                const msg = `<span style="font-size: 24px;">⚠️</span> For Coat Size ${coatid}${categoryInitial}: Recommended Vest ${recommendedVest}.`;
                setVestRecommendationMsg(msg);
                localStorage.setItem('vestRecommendationMsg', msg);
            }

            return; // Exit here so it doesn't run height-weight logic
        }

        // Case 2: No coat size, but height and valid weight present
        if (selectedHeight && weight) {
            const isWeightValid =
                weight !== null && weight !== undefined && !isNaN(weight) && weight !== "";

            const validSizeCharts = sizes
                .flatMap(category => category.size_charts)
                .filter(size =>
                    size.minHeight !== null &&
                    size.maxHeight !== null &&
                    selectedHeight >= size.minHeight &&
                    selectedHeight <= size.maxHeight
                );

            let isWeightInRange = false;
            if (isWeightValid) {
                isWeightInRange = validSizeCharts.some(chart =>
                    (!chart.minWeight || Number(weight) >= chart.minWeight) &&
                    (!chart.maxWeight || Number(weight) <= chart.maxWeight)
                );
            }

            if (isWeightValid && isWeightInRange && validSizeCharts.length > 0) {
                let foundChart = null;

                for (const category of sizes || []) {
                    if (category.size_charts && category.size_charts.length > 0) {
                        foundChart = category.size_charts[0];
                        break;
                    }
                }

                if (foundChart) {
                    const recommendedVest = String(foundChart?.vestSize || "").trim();

                    if (selectedValue?.value && String(selectedValue.value) !== recommendedVest) {

                        const msg = `<span style="font-size: 24px;">⚠️</span> Based on Height (${formattedHeight}) and Weight (${weight}): Recommended Vest ${recommendedVest}.`;
                        setVestRecommendationMsg(msg);
                        localStorage.setItem('vestRecommendationMsg', msg);

                    }
                }
            }
        }
    };

    // Add this function to your component
    const openAccordionWithErrors = (errors, hasCategoryValidationMessage = false) => {
        // Check which accordion tabs have errors
        const errorFields = Object.keys(errors);

        // Check if Coat section has errors
        const coatErrors = ['Coat', 'CoatSize', 'Insleeve'].some(field => errorFields.includes(field)) || hasCategoryValidationMessage;

        // Check if Pant section has errors
        const pantErrors = ['Pant', 'Waist', 'hip', 'outseam'].some(field => errorFields.includes(field));

        // Check if Vest section has errors (if you have a vest section)
        const shirtErrors = ['Shirt', 'ShirtSize'].some(field => errorFields.includes(field)) ||
            (showSleeve && errorFields.includes('Sleeve'));

        const vestErrors = ['Vest', 'VestColor'].some(field => errorFields.includes(field));
        const tieErrors = ['Tie', 'Pocket', 'Jewelry'].some(field => errorFields.includes(field));
        const shoesErrors = ['Shoes', 'ShoesSize'].some(field => errorFields.includes(field));


        if (coatErrors) {
            setActiveItem(1); // Use the ID that corresponds to your coat accordion
        } else if (pantErrors) {
            setActiveItem(2); // Use the ID that corresponds to your pant accordion
        } else if (shirtErrors) {
            setActiveItem(3); // Use the ID that corresponds to your shirt accordion
        } else if (vestErrors) {
            setActiveItem(4); // Use the ID that corresponds to your vest accordion
        } else if (tieErrors) {
            setActiveItem(5); // Use the ID that corresponds to your tie accordion
        } else if (shoesErrors) {
            setActiveItem(6); // Use the ID that corresponds to your shoes accordion
        }
        // Add more conditions for other accordions if needed
    };
    // Modify your onNext function to include this check
    const handleNext = (data) => {
        if (categoryName) {
            data.categoryName = categoryName;
            localStorage.setItem('selectedCategoryName', categoryName);
            localStorage.setItem('isCategorySelected', 'true');
        }
        if (Object.keys(formState.errors).length > 0 || categoryValidationMessage) {
            openAccordionWithErrors(formState.errors, !!categoryValidationMessage);
            return; // Prevent calling the parent onNext
        }
        onNext(data);
    };

    const pantStyle = watch("Pant");
    const currentBeltValue = watch("belt");
    const [hasUserSelected, setHasUserSelected] = useState(false);
    const [hasInitialLoadCompleted, setHasInitialLoadCompleted] = useState(false);

    // Get allowed pant styles
    const allowedPantStyles = sortedPants
        .filter(data => data?.style && data?.belt !== null)
        .map(data => data.style.toString());

    // Check if we should show belt
    const shouldShowBelt = pantStyle && allowedPantStyles.includes(pantStyle.toString());

    // Create belt color map
    const beltColorMap = {};
    sortedPants.forEach((data) => {
        if (data?.style && data?.belt !== null) {
            beltColorMap[data.style] = data.belt;
        }
    });

    // Available colors and default mapping
    const availableColors = ["Black", "Brown", "Cognac", "White"];
    const mappedDefaultColor = beltColorMap[pantStyle] || availableColors[0];

    // Handle initial load and default logic
    useEffect(() => {
        if (!shouldShowBelt) return;

        // On first load only
        if (!hasInitialLoadCompleted) {
            // Priority 1: Use initial value if exists
            if (initialValues?.belt) {
                setValue("belt", initialValues.belt, { shouldValidate: true });
                setHasUserSelected(true);
            }
            // Priority 2: Use mapped default color
            else if (mappedDefaultColor && !currentBeltValue) {
                setValue("belt", mappedDefaultColor, { shouldValidate: true });
            }
            setHasInitialLoadCompleted(true);
            return;
        }

        // After initial load, handle pant changes
        if (!hasUserSelected && mappedDefaultColor && (!currentBeltValue || currentBeltValue !== mappedDefaultColor)) {
            setValue("belt", mappedDefaultColor, { shouldValidate: true });
        }
    }, [shouldShowBelt, pantStyle, initialValues, hasInitialLoadCompleted, hasUserSelected, currentBeltValue, setValue, mappedDefaultColor]);

    // Reset user selection when pant changes
    useEffect(() => {
        setHasUserSelected(false);
    }, [pantStyle]);

    // Clear belt if pant style doesn't allow belts
    useEffect(() => {
        if (pantStyle && !allowedPantStyles.includes(pantStyle.toString()) && currentBeltValue) {
            setValue("belt", "", { shouldValidate: true });
        }
    }, [pantStyle, allowedPantStyles, currentBeltValue, setValue]);

    return (
        <Container>
            <div class="nk-content ">
                <div class="container-fluid">
                    <div class="nk-content-inner">
                        <div class="nk-content-body">
                            <div class="nk-block-head nk-block-head-sm">
                                <div class="nk-block-between">
                                    <div class="nk-block-head-content">
                                        <h3 class="nk-block-title page-title">{location.pathname == "/add-order" ? "Add" : "Update"} {
                                            profile?.name === "Admin"
                                            && `#${account?.substring(0, 2) || ''}`
                                        } Order {(ticket && location.pathname != "/add-order") && `#${ticket}`}</h3></div>

                                </div>
                            </div>

                            <div class="card card-full">
                                <div class="card-inner">
                                    <div class="stepperLeft">
                                        <div className="row">
                                            <div className="col-md-4 brIght">
                                                <section class="section1">
                                                    <header>
                                                        <div class="bead complete"><span><i class="fa-solid fa-check"></i></span></div> {location.pathname == "/add-order" ? "Add" : "Update"} Member
                                                    </header>
                                                </section>
                                                <section class="section2">
                                                    <header>
                                                        <div class="bead current"><span>2</span></div>{location.pathname == "/add-order" ? "Add" : "Update"} Sizes
                                                    </header>
                                                </section>
                                                <section>
                                                    <header>
                                                        <div class="bead"><span>3</span></div> {location.pathname == "/add-order" ? "Add" : "Update"} Notes
                                                    </header>
                                                </section>

                                            </div>

                                            <div className="col-md-8">
                                                <div className="row">
                                                    <div className="d-flex align-items-center justify-content-between w-100 ">
                                                        <h4>{location.pathname == "/add-order" ? "Add" : "Update"} Sizes {location.pathname !== "/add-order" && initialValues?.Firstname && (
                                                            <> - {initialValues.Firstname} {initialValues.Lastname}</>)}</h4>

                                                    </div></div>
                                                <form onSubmit={handleSubmit(handleNext)}>

                                                    <div className="inputCardBox mt-4">

                                                        <div className="row">

                                                            <div className="col-6 col-md-6 mb-3 stateSelect">
                                                                <label>Height <span className="text-red-500">*</span></label>


                                                                <Controller
                                                                    name="Height"
                                                                    control={control}
                                                                    rules={{ required: "Height is required" }}
                                                                    render={({ field }) => (
                                                                        <Select
                                                                            {...field}
                                                                            options={getHeightOptions()}
                                                                            placeholder="Select height"
                                                                            isClearable
                                                                            onChange={(selectedOption) => {
                                                                                if (!selectedOption) {
                                                                                    field.onChange('');
                                                                                    setSelectedHeight("");
                                                                                    setSelectedCoatSize("");
                                                                                    setValue("Weight", "");
                                                                                    setValue("coatsize_chart_id", "");
                                                                                    setValue("CoatSize", "")
                                                                                    setValue("Insleeve", "")
                                                                                    setValue("Waist", "");
                                                                                    setValue("hip", "");
                                                                                    setValue("outseam", "");
                                                                                    setValue("ShirtSize", "");
                                                                                    setValue("VestColor", "");
                                                                                    setValue("Sleeve", "");
                                                                                    setMatchedItems([]);
                                                                                    setCategoryName('')
                                                                                    setSizeRecommendationMsg("");
                                                                                    setShirtSizeRecommendationMsg("");
                                                                                    setVestRecommendationMsg("");

                                                                                    // Also clear localStorage
                                                                                    localStorage.removeItem('pantSizeRecommendationMsg');
                                                                                    localStorage.removeItem('shirtSizeRecommendationMsg');
                                                                                    localStorage.removeItem('vestRecommendationMsg');
                                                                                    localStorage.removeItem('selectedCoatSize');
                                                                                    localStorage.removeItem('coatid');
                                                                                    localStorage.removeItem('selectedCategoryName');
                                                                                } else {
                                                                                    field.onChange(selectedOption.value);
                                                                                    setSelectedHeight(selectedOption.value);
                                                                                    const heightVal = selectedOption.value;
                                                                                    let heightInInches;
                                                                                    if (typeof heightVal === 'string' && heightVal.includes("'")) {
                                                                                        heightInInches = convertHeightToInches(heightVal);
                                                                                    } else {
                                                                                        heightInInches = parseInt(heightVal, 10);
                                                                                    }

                                                                                    if (heightInInches < 61) { // Less than 5'1"
                                                                                        setOrderForState("Boys");
                                                                                        setValue("order_for", "Boys");
                                                                                    } else {
                                                                                        setOrderForState("Men");
                                                                                        setValue("order_for", "Men");
                                                                                    }
                                                                                    setSelectedCoatSize("");
                                                                                    setValue("Weight", "");
                                                                                    setValue("coatsize_chart_id", "");
                                                                                    setValue("CoatSize", "")
                                                                                    setValue("Insleeve", "")
                                                                                    setValue("Waist", "");
                                                                                    setValue("hip", "");
                                                                                    setValue("outseam", "");
                                                                                    setValue("ShirtSize", "");
                                                                                    setValue("VestColor", "");
                                                                                    setValue("Sleeve", "");
                                                                                    setMatchedItems([]);
                                                                                    setCategoryName('')
                                                                                    // Reset all the messages (both state and localStorage)
                                                                                    setSizeRecommendationMsg("");
                                                                                    setShirtSizeRecommendationMsg("");
                                                                                    setVestRecommendationMsg("");

                                                                                    // Clear localStorage
                                                                                    localStorage.removeItem('pantSizeRecommendationMsg');
                                                                                    localStorage.removeItem('shirtSizeRecommendationMsg');
                                                                                    localStorage.removeItem('vestRecommendationMsg');
                                                                                    localStorage.removeItem('selectedCoatSize');
                                                                                    localStorage.removeItem('coatid');
                                                                                    localStorage.removeItem('selectedCategoryName');
                                                                                }
                                                                            }}
                                                                            value={getHeightOptions().find(option => option.value === field.value) || null}
                                                                            isOptionDisabled={(option) => option.isDisabled}
                                                                        />
                                                                    )}
                                                                />
                                                                {errors.Height && <p className='red'>{errors.Height.message}</p>}
                                                            </div>
                                                            <div className="col-6 col-md-6 mb-3">
                                                                <label>Weight <small>(  2 or 3 Digits Only )</small> <span className="text-red-500">*</span></label>
                                                                <input class="" type="text" placeholder="Enter weight"
                                                                    {...register("Weight", {
                                                                        required: "Weight is required",
                                                                        pattern: {
                                                                            value: /^[1-9]$|^[1-9][0-9]$|^[1-9][0-9]{2}$/, // This regex ensures 1, 2, or 3 digits (from 1 to 999)
                                                                            message: "Weight must be a maximum of 3 digits"
                                                                        },
                                                                        onChange: () => {

                                                                        }
                                                                    })}
                                                                />
                                                                {errors.Weight && <p className='red'>{errors.Weight.message}</p>}
                                                            </div>

                                                            <div className="col-6 col-md-6 mb-3">
                                                                <label>Chest <small>( 2 Digits Only )</small> <span className="text-red-500"></span></label>
                                                                <input
                                                                    type="text"
                                                                    inputMode="numeric"
                                                                    pattern="[0-9]*"
                                                                    placeholder="Enter chest"
                                                                    maxLength={2}
                                                                    onKeyPress={(e) => {
                                                                        // Allow only numeric keys, backspace, delete, tab, enter
                                                                        if (!/[0-9]/.test(e.key) && !['Backspace', 'Delete', 'Tab', 'Enter'].includes(e.key)) {
                                                                            e.preventDefault();
                                                                        }
                                                                    }}
                                                                    onChange={(e) => {
                                                                        const val = e.target.value;
                                                                        if (/^\d{0,2}$/.test(val)) {
                                                                            setValue("Chest", val); // from react-hook-form
                                                                        }
                                                                    }}
                                                                    value={watch("Chest")}
                                                                    {...register("Chest", {
                                                                        required: false,
                                                                        validate: (value) => {
                                                                            if (value) {
                                                                                if (!/^\d{1,2}$/.test(value)) {
                                                                                    return "Chest must be 1-2 digits (1-99)";
                                                                                }
                                                                                const num = parseInt(value, 10);
                                                                                if (num < 1 || num > 99) {
                                                                                    return "Chest must be between 1-99";
                                                                                }
                                                                            }
                                                                            return true;
                                                                        },
                                                                    })}
                                                                />
                                                                {errors.Chest && <p className='red'>{errors.Chest.message}</p>}
                                                            </div>

                                                            <div className="col-6 col-md-6 mb-3">
                                                                <label>Overarm <small>( 2 Digits only) </small> <span className="text-red-500"></span></label>
                                                                <input
                                                                    type="text"
                                                                    inputMode="numeric"
                                                                    pattern="[0-9]*"
                                                                    placeholder="Enter overarm"
                                                                    maxLength={2}
                                                                    onKeyPress={(e) => {
                                                                        // Allow only numeric keys, backspace, delete, tab, enter
                                                                        if (!/[0-9]/.test(e.key) && !['Backspace', 'Delete', 'Tab', 'Enter'].includes(e.key)) {
                                                                            e.preventDefault();
                                                                        }
                                                                    }}
                                                                    onChange={(e) => {
                                                                        const val = e.target.value;
                                                                        if (/^\d{0,2}$/.test(val)) {
                                                                            setValue("Overarm", val);
                                                                        }
                                                                    }}
                                                                    value={watch("Overarm")}
                                                                    {...register("Overarm", {
                                                                        // Make the field optional
                                                                        required: false,
                                                                        // Apply validation only if the field is filled
                                                                        validate: (value) => {
                                                                            if (value && !/^\d{2}$/.test(value)) {
                                                                                return "Overarm must be a 2-digits number";
                                                                            }
                                                                            const num = parseInt(value, 10);
                                                                            if (num < 1 || num > 99) {
                                                                                return "Chest must be between 1-99";
                                                                            }
                                                                            return true;
                                                                        },
                                                                    })}
                                                                />
                                                                {errors.Overarm && <p className='red'>{errors.Overarm.message}</p>}
                                                            </div>
                                                        </div>

                                                        <div className="newAccordion">
                                                            <div className={"accordionContainer"}>
                                                                <AccordionItem
                                                                    id={1}
                                                                    title={
                                                                        LebelCoat?.style ? (
                                                                            <span className="fw-400">
                                                                                <strong className="fw-700">Coat Style</strong> ({LebelCoat?.style} {LebelCoat?.description} -
                                                                                <span><strong className="fw-700">{LebelCoatsize ? LebelCoatsize : 'N/A'}
                                                                                    {LebelCoatsize && LabelcategoryName === 'Short' ? 'S' :
                                                                                        LabelcategoryName === 'Regular' ? 'R' :
                                                                                            LabelcategoryName === 'Long' ? 'L' :
                                                                                                LabelcategoryName === 'Extra Long' ? 'X' :
                                                                                                    LabelcategoryName === 'Boys' ? 'B' :
                                                                                                        LabelcategoryName})</strong></span>
                                                                            </span>
                                                                        ) : (
                                                                            <span><strong className="fw-700">Coat Style</strong></span>
                                                                        )
                                                                    }                                                                                                                                     >
                                                                    <div className="accordion-inner">
                                                                        <div className="row">
                                                                            <div className="col-md-8 p-0 stateSelect">
                                                                                <div className="row">
                                                                                    <div className="col-md-6 mb-3">
                                                                                        <label>Coat Style<span className="text-red-500"></span></label>
                                                                                        <Controller
                                                                                            name="Coat"
                                                                                            control={control}
                                                                                            // rules={{ required: "Coat is required" }}
                                                                                            render={({ field }) => (
                                                                                                <Select
                                                                                                    {...field} options={sortedOptions}
                                                                                                    placeholder="Select"
                                                                                                    components={customComponents}
                                                                                                    isClearable
                                                                                                    onChange={(selectedOption) => {
                                                                                                        field.onChange(selectedOption ? selectedOption.value : '');
                                                                                                        handleCoatChange(selectedOption);

                                                                                                    }}
                                                                                                    value={options.find(option => option.value === field.value) || null}

                                                                                                />
                                                                                            )}
                                                                                        />
                                                                                        {errors.Coat && <p className='red'>{errors.Coat.message}</p>}
                                                                                    </div>
                                                                                    <div className="col-md-6 mb-3">
                                                                                        <h6 className="mb-0 mt-1">{Coatstyle?.style ? `#${Coatstyle.style} ` : ''}</h6>
                                                                                        <p className="coatTxtPra"><small>{Coatstyle?.description}</small></p>
                                                                                    </div>

                                                                                    <div >
                                                                                        <a href="" data-bs-toggle="modal" data-bs-target="#alterationsCoatModal"></a>
                                                                                    </div>
                                                                                    <div className="col-12 col-md-6 mb-3">
                                                                                        <label>Coat Size<span className="text-red-500">*</span></label>
                                                                                        <Controller
                                                                                            name="CoatSize"
                                                                                            control={control}
                                                                                            // rules={coatSizeValidation}
                                                                                            rules={{
                                                                                                // ...coatSizeValidation, // Ye aapka existing validation rule ho sakta hai
                                                                                                validate: (value) => {
                                                                                                    if (Object.keys(coatSizeValidation).length === 0) {
                                                                                                        return true;
                                                                                                    }
                                                                                                    if (!value) {
                                                                                                        return true;
                                                                                                    }
                                                                                                    if (value && !categoryName) {
                                                                                                        return "Please select a category before continuing.";
                                                                                                    }
                                                                                                    // Custom validation for category message
                                                                                                    if (value && categoryValidationMessage) {
                                                                                                        return categoryValidationMessage; // Show custom error message
                                                                                                    }
                                                                                                    if (coatSizeValidation.required &&
                                                                                                        (value === null || value === undefined || value === "")) {
                                                                                                        return coatSizeValidation.required;
                                                                                                    }
                                                                                                    return true; // Validation pass
                                                                                                }
                                                                                            }}
                                                                                            render={({ field }) => {
                                                                                                // Get all unique coat sizes from the sizes array
                                                                                                const uniqueCoatSizes = sizes
                                                                                                    .filter(category => category.size_charts.length > 0)
                                                                                                    .flatMap(category => category.size_charts.map(size => size.coatSize));

                                                                                                // Filter only categories that have size charts
                                                                                                const filteredCategories = sizes.filter(category => category.size_charts.length > 0);
                                                                                                const availableCoatSizes = !selectedHeight
                                                                                                    ? []
                                                                                                    : (AllSize?.coatSizes || []).map(size => ({
                                                                                                        value: size,
                                                                                                        label: size.toString(),
                                                                                                    }));


                                                                                                // Get the maximum bold value
                                                                                                const maxBoldValue = Math.max(...uniqueCoatSizes);

                                                                                                // Modify your sorting function
                                                                                                const sortedOptions = [...availableCoatSizes].sort((a, b) => {
                                                                                                    // First prioritize by whether they're bold values
                                                                                                    const aIsBold = uniqueCoatSizes.includes(a.value);
                                                                                                    const bIsBold = uniqueCoatSizes.includes(b.value);

                                                                                                    if (aIsBold !== bIsBold) {
                                                                                                        return aIsBold ? -1 : 1; // Bold values come first
                                                                                                    }

                                                                                                    // For values after the max bold value, put them at the top
                                                                                                    const aIsAfterMaxBold = a.value > maxBoldValue;
                                                                                                    const bIsAfterMaxBold = b.value > maxBoldValue;

                                                                                                    if (aIsAfterMaxBold !== bIsAfterMaxBold) {
                                                                                                        return aIsAfterMaxBold ? -1 : 1; // Values after max bold come next
                                                                                                    }

                                                                                                    // Otherwise sort numerically
                                                                                                    return a.value - b.value;
                                                                                                });
                                                                                                const defaultValue = sortedOptions.find(opt => opt.value === (selectedCoatSize || initialValues.CoatSize)) || null;

                                                                                                return (
                                                                                                    <>
                                                                                                        <Select
                                                                                                            {...field}
                                                                                                            options={sortedOptions}
                                                                                                            placeholder="Select coat size"
                                                                                                            isClearable

                                                                                                            value={sortedOptions.find(option => option.value === selectedCoatSize) || null}
                                                                                                            onMenuOpen={() => {
                                                                                                                if (!selectedHeight) {
                                                                                                                    toast.error("Please select height.");
                                                                                                                }
                                                                                                            }}

                                                                                                            onChange={(selectedOption) => {
                                                                                                                if (!selectedOption) {
                                                                                                                    field.onChange(null);
                                                                                                                    setValue("coatsize_chart_id", null);
                                                                                                                    setcoat(null);
                                                                                                                    setMatchedItems([]);
                                                                                                                    setCategoryName('')
                                                                                                                    setTempCoatSize(null);
                                                                                                                    setNonBoldMessage("");
                                                                                                                    localStorage.removeItem('selectedCategoryName'); // Make sure to remove category name when coat is cleared

                                                                                                                    localStorage.removeItem('coatid');
                                                                                                                    setSelectedCoatSize(null);
                                                                                                                    setCategoryValidationMessage('');
                                                                                                                    setSizeRecommendationMsg("");
                                                                                                                    setShirtSizeRecommendationMsg("");
                                                                                                                    setVestRecommendationMsg("");
                                                                                                                    setCoatid(null);
                                                                                                                    setRecommendationMessage("");
                                                                                                                    localStorage.removeItem('selectedCoatSize');
                                                                                                                    localStorage.removeItem('recommendationMessage'); // Add this line to remove from localStorage
                                                                                                                    localStorage.removeItem('nonBoldMessage'); // Add this line to remove from localStorage
                                                                                                                    localStorage.removeItem('selectedCategoryName')

                                                                                                                    if (selectedHeight && weight) {
                                                                                                                        setWaistSizes([]);
                                                                                                                        setHipSizes([]);
                                                                                                                        setoutseamSizes([]);


                                                                                                                    }
                                                                                                                    field.onChange(null);
                                                                                                                    setCategoryValidationMessage(''); // Clear validation message when coat size is cleared

                                                                                                                    return;
                                                                                                                }

                                                                                                                setSelectedCoatSize(selectedOption.value);
                                                                                                                const selectedSize = selectedOption.value;
                                                                                                                const isBold = uniqueCoatSizes.includes(selectedSize);
                                                                                                                const weightValue = watch("Weight");
                                                                                                                setValue("CoatSize", selectedOption.value);
                                                                                                                setValue("coatsize_chart_id", selectedOption.value);
                                                                                                                setcoat(selectedOption.value);
                                                                                                                setCoatid(selectedOption.value);
                                                                                                                setStoprender(true);

                                                                                                                if (categoryName) {
                                                                                                                    validateSizeWithCategory(selectedOption.value, categoryName, categorySizes, selectedStyle);
                                                                                                                }
                                                                                                                let recommendationMessage = "";
                                                                                                                if (selectedHeight) {
                                                                                                                    const feet = Math.floor(selectedHeight / 12);
                                                                                                                    const inches = selectedHeight % 12;
                                                                                                                    const formattedHeight = `${feet}'${inches}''`;
                                                                                                                    const sortedBoldSizes = [...uniqueCoatSizes].sort((a, b) => a - b);
                                                                                                                    const firstBoldSize = sortedBoldSizes[0];
                                                                                                                    const lastBoldSize = sortedBoldSizes[sortedBoldSizes.length - 1];

                                                                                                                    const selectedSizeChart = sizes
                                                                                                                        .flatMap(category => category.size_charts)
                                                                                                                        .find(size => size.coatSize === selectedCoatSize);

                                                                                                                    const minWeight = selectedSizeChart?.minWeight || null;
                                                                                                                    const maxWeight = selectedSizeChart?.maxWeight || null;

                                                                                                                    if (weightValue && minWeight !== null && maxWeight !== null) {

                                                                                                                    }
                                                                                                                }

                                                                                                                if (!isBold) {
                                                                                                                    setNonBoldMessage(recommendationMessage);
                                                                                                                } else {
                                                                                                                    if (!recommendationMessage) {
                                                                                                                        setNonBoldMessage("");
                                                                                                                    }
                                                                                                                }

                                                                                                                localStorage.setItem('selectedCoatSize', selectedSize);
                                                                                                                localStorage.setItem('coatid', selectedSize);
                                                                                                                localStorage.setItem('selectedCategoryName', categoryName);

                                                                                                                field.onChange(selectedOption.value);
                                                                                                                if (selectedStyle && availableSizesForStyle.length > 0) {
                                                                                                                    const coatSizeNum = Number(selectedOption.value);

                                                                                                                    if (!availableSizesForStyle.includes(coatSizeNum)) {
                                                                                                                        const categoryInitial = categoryName ?
                                                                                                                            (categoryName.charAt(0).toUpperCase() === "E" ? "X" : categoryName.charAt(0)) :
                                                                                                                            '';

                                                                                                                        const selectedStyleObj = coatStyles.find(style => style.inventory_id == selectedStyle);
                                                                                                                        const styleLabel = selectedStyleObj?.label || selectedStyle;

                                                                                                                        setStyleValidationMessage(`Selected Coat Style ${styleLabel} doesn't have coat size ${selectedOption.value}${categoryInitial}.`);
                                                                                                                    } else {
                                                                                                                        setStyleValidationMessage('');
                                                                                                                    }
                                                                                                                }
                                                                                                            }
                                                                                                            }
                                                                                                            formatOptionLabel={(option, { context }) => (
                                                                                                                <div style={uniqueCoatSizes.includes(option.value) ? { fontWeight: 'bold' } : {}}>
                                                                                                                    {option.label}
                                                                                                                </div>
                                                                                                            )}
                                                                                                        />
                                                                                                        {errors.CoatSize && (
                                                                                                            <span
                                                                                                                style={{
                                                                                                                    backgroundColor: 'red',
                                                                                                                    color: 'white',
                                                                                                                    marginTop: '8px'
                                                                                                                }}
                                                                                                            >
                                                                                                                {errors.CoatSize.message}
                                                                                                            </span>
                                                                                                        )}
                                                                                                        {categoryValidationMessage && (
                                                                                                            <p style={{
                                                                                                                backgroundColor: '#FF0000',
                                                                                                                color: '#FFFFFF', fontSize: '12px', whiteSpace: 'nowrap'
                                                                                                            }} className="font-bold mt-2">
                                                                                                                {/* <i className="fa fa-exclamation-circle" style={{ marginRight: 5 }}></i> */}
                                                                                                                {categoryValidationMessage}</p>
                                                                                                        )}


                                                                                                        {orderForState === "Boys" && field.value && (
                                                                                                            <p className="text-blue-600 font-bold mt-2"></p>
                                                                                                        )}


                                                                                                        <div className="col-md-12">
                                                                                                            <div className="d-flex flex-wrap mt-3">

                                                                                                                {coatid && allSizes.map((category, index) => {
                                                                                                                    const isShortCategory = category.name.length < 3;
                                                                                                                    const isCurrentCategory = category.name === categoryName && !!categoryName;
                                                                                                                    const hasData = category.size_charts && category.size_charts.length > 0;

                                                                                                                    // ✅ New: Check if category belongs to the selected coat size
                                                                                                                    const isCoatSizeCategory = category.size_charts?.some(chart => chart.coatSize === coatid);

                                                                                                                    // Keep existing logic for selected category, but enable all categories for the coat size
                                                                                                                    const isEnabled = hasData && (isCoatSizeCategory || isCurrentCategory);

                                                                                                                    return (
                                                                                                                        <div
                                                                                                                            key={index}
                                                                                                                            className={`
                coatSizeCategorySize px-2 py-1 rounded-lg mx-1 
                ${hasData && coatid ?
                                                                                                                                    (isEnabled ?
                                                                                                                                        (isCurrentCategory ? 'bg-blue-600 text-white border-2 border-blue-700 font-bold transform scale-110 z-10' : 'bg-green-500 selectedBox')
                                                                                                                                        : 'disableSize text-black')
                                                                                                                                    : 'bg-gray-300 text-gray-500 cursor-not-allowed'
                                                                                                                                } 
                ${isShortCategory && !isCurrentCategory ? 'border-blue-500 border-2' : ''} 
                ${isCurrentCategory ? "blueSelected" : ""}
            `}
                                                                                                                            onClick={isEnabled ? () => {
                                                                                                                                const categoryId = category.id;
                                                                                                                                setIsUserSelectedCategory(true);
                                                                                                                                setSizeid(category.id);
                                                                                                                                setValue("size_chart_category_id", category?.id);
                                                                                                                                setCategoryName(category.name);
                                                                                                                                localStorage.setItem('selectedCategoryName', category.name);
                                                                                                                                localStorage.setItem('selectedCategoryId', categoryId);
                                                                                                                                localStorage.setItem('isCategorySelected', 'true');
                                                                                                                                localStorage.setItem('size', categoryId);

                                                                                                                                clearErrors("CoatSize");
                                                                                                                                setStoprender(false);
                                                                                                                                if (selectedCoatSize) {
                                                                                                                                    validateSizeWithCategory(selectedCoatSize, category.name, categorySizes, selectedStyle);
                                                                                                                                }
                                                                                                                            } : undefined}
                                                                                                                        >
                                                                                                                            {category.name.charAt(0).toUpperCase() === "E" ? "X" : category.name.charAt(0)}
                                                                                                                        </div>
                                                                                                                    );
                                                                                                                })}



                                                                                                                {coatid && categoryName && (
                                                                                                                    <p className="text-lg font-bold text-blue-700 mt-3">
                                                                                                                        <strong>Size:</strong> {categoryName}
                                                                                                                    </p>
                                                                                                                )}
                                                                                                            </div>




                                                                                                        </div>


                                                                                                    </>
                                                                                                );
                                                                                            }}
                                                                                        />
                                                                                    </div>




                                                                                    <div className="col-12 col-md-6 mb-3">
                                                                                        <label>Insleeve<span className="text-red-500"></span></label>
                                                                                        <Controller
                                                                                            name="Insleeve"
                                                                                            control={control}
                                                                                            // rules={insleeveValidation} // Conditional validation
                                                                                            render={({ field }) => {

                                                                                                const insleeveTimes = [];
                                                                                                for (let time = 8.0; time <= 20.5; time += 0.5) {
                                                                                                    insleeveTimes.push({
                                                                                                        value: time.toString(),
                                                                                                        label: time.toString(),
                                                                                                    });
                                                                                                }
                                                                                                // Manually add "14.25" if it's missing
                                                                                                if (!insleeveTimes.some(option => option.value === "14")) {
                                                                                                    insleeveTimes.push({ value: "14", label: "14" });
                                                                                                }


                                                                                                return (
                                                                                                    <Select
                                                                                                        {...field}
                                                                                                        options={insleeveTimes}
                                                                                                        placeholder="Select"
                                                                                                        isClearable
                                                                                                        onChange={(selectedOption) => {
                                                                                                            field.onChange(selectedOption ? selectedOption.value : '');

                                                                                                            if (selectedOption) {
                                                                                                                localStorage.setItem('savedInsleeve', selectedOption.value);
                                                                                                            } else {
                                                                                                                localStorage.removeItem('savedInsleeve');
                                                                                                                setIsUserSelectedInsleeve(false); // Reset if cleared
                                                                                                            }
                                                                                                            if (!selectedOption) {

                                                                                                                setdefaultsize(null)

                                                                                                                return;
                                                                                                            }
                                                                                                            if (selectedOption && selectedOption.value !== defaultsize) {
                                                                                                                const modalTrigger = document.querySelector('[data-bs-target="#alterationsCoatModal"]');
                                                                                                                if (modalTrigger) {
                                                                                                                    modalTrigger.click();
                                                                                                                }
                                                                                                            }
                                                                                                        }}
                                                                                                        value={field.value ? insleeveTimes.find(option => option.value === field.value) : ''}
                                                                                                    // value={field.value ? insleeveTimes.find(option => option.value === field.value) : defaultValue}

                                                                                                    />
                                                                                                );
                                                                                            }}
                                                                                        />
                                                                                        {errors.Insleeve && <p className='red'>{errors.Insleeve.message}</p>}

                                                                                        {
                                                                                            defaultsize && <p className="sleeveTxt"><small>Sleeve alterations: $6.00/coat, except default size {defaultsize}.</small></p>

                                                                                        }
                                                                                    </div>

                                                                                    {selectedCoatSize && nonBoldMessage && (
                                                                                        <p
                                                                                            className="text-red-600 font-bold mt-2">
                                                                                            <span
                                                                                                style={{ backgroundColor: 'lightyellow', padding: '2px 12px', borderRadius: '4px', color: 'black' }}
                                                                                                dangerouslySetInnerHTML={{ __html: nonBoldMessage }}
                                                                                            /></p>
                                                                                    )}

                                                                                    {selectedCoatSize && recommendationMessage && (
                                                                                        <p
                                                                                            className="text-red-600 font-bold mt-2">
                                                                                            <span
                                                                                                style={{ backgroundColor: 'lightyellow', padding: '2px 12px', borderRadius: '4px', color: 'black' }}
                                                                                                dangerouslySetInnerHTML={{ __html: recommendationMessage }}
                                                                                            /></p>
                                                                                    )}

                                                                                </div >
                                                                            </div >

                                                                            <div className="col-md-4 addStyleMobileImg">
                                                                                {Coatstyle?.image ? (
                                                                                    <Image src={`${ImageUrl}${Coatstyle?.image}`} className="noSelectCoatImg" alt="" />
                                                                                ) : (
                                                                                    <img src="/assets/images/no-photo.png" className="selectCoatImg" alt="" />
                                                                                )}
                                                                            </div>
                                                                        </div >
                                                                    </div >
                                                                </AccordionItem>
                                                                <AccordionItem
                                                                    id={2}
                                                                    title={
                                                                        Lebelpant?.style ? (
                                                                            <span className="fw-400">
                                                                                <strong className="fw-700">Pant Style</strong> ({Lebelpant?.style} {Lebelpant?.description} -
                                                                                <span><strong className="fw-700"> {Lebelpantsize ? Lebelpantsize : 'N/A'}</strong></span>)
                                                                            </span>
                                                                        ) : (
                                                                            <span><strong className="fw-700">Pant Style</strong></span>
                                                                        )
                                                                    }
                                                                >
                                                                    <div className="accordion-inner">
                                                                        <div className="row">
                                                                            <div className="col-md-8 p-0 stateSelect">
                                                                                <div className="row">
                                                                                    {/* Pant Style Field */}
                                                                                    <div className="col-md-6 mb-3">
                                                                                        <label>Pant Style<span className="text-red-500"></span></label>
                                                                                        <Controller
                                                                                            name="Pant"
                                                                                            control={control}
                                                                                            // rules={{ required: "Pant is required" }}
                                                                                            render={({ field }) => {
                                                                                                const pantOptions = getPantOptions();
                                                                                                return (
                                                                                                    <Select
                                                                                                        {...field}
                                                                                                        options={pantOptions}

                                                                                                        placeholder="Select"
                                                                                                        components={customComponents}
                                                                                                        isClearable
                                                                                                        formatOptionLabel={(option) => (
                                                                                                            <div style={option.isMatched ? { fontWeight: 'bold' } : {}}>
                                                                                                                {option.label}
                                                                                                            </div>
                                                                                                        )}
                                                                                                        onChange={(selectedOption) => {
                                                                                                            const selectedValue = selectedOption ? selectedOption.value : '';
                                                                                                            field.onChange(selectedValue); // Update form value
                                                                                                            const syntheticEvent = { target: { value: selectedValue } };
                                                                                                            handlePaintChange(syntheticEvent); // Trigger change handler
                                                                                                        }}
                                                                                                        value={
                                                                                                            pantOptions.find(option => option.value === field.value) || null
                                                                                                        }

                                                                                                    />
                                                                                                )
                                                                                            }}
                                                                                        />
                                                                                        {errors.Pant && <p className='red'>{errors.Pant.message}</p>}
                                                                                    </div>

                                                                                    {/* Display Pant Style Details */}
                                                                                    <div className="col-md-6 mb-3">
                                                                                        <h6 className="mb-0 mt-1">{Pantstyle?.style ? `#${Pantstyle.style}` : ''}</h6>
                                                                                        <p className="coatTxtPra"><small>{Pantstyle?.description}</small></p>
                                                                                    </div>

                                                                                    {/* Waist Field */}
                                                                                    <div className="col-md-6 mb-3">
                                                                                        <label>Waist <span className="text-red-500"></span></label>
                                                                                        <Controller
                                                                                            name="Waist"
                                                                                            control={control}
                                                                                            rules={{
                                                                                                required: false, validate: (value) => {
                                                                                                    return validatePantSize(value);
                                                                                                },
                                                                                            }}

                                                                                            // rules={{ required: pantStyleSelected ? "Waist is required" : false }}
                                                                                            render={({ field }) => {
                                                                                                const boldSizes = waistSizes.map(Number); // e.g. [28, 29, 30, 31]
                                                                                                const allSizes = pantStyleSelected
                                                                                                    ? pantStyleSizes?.waistSizes || []
                                                                                                    : AllSize?.waistSizes || [];

                                                                                                const numericAllSizes = allSizes.map(Number);
                                                                                                const maxBold = Math.max(...boldSizes);
                                                                                                const minBold = Math.min(...boldSizes);

                                                                                                // // Sort into groups:


                                                                                                const boldOptions = numericAllSizes
                                                                                                    .filter(size =>
                                                                                                        recommendedRange &&
                                                                                                        size >= recommendedRange.waistMin &&
                                                                                                        size <= recommendedRange.waistMax
                                                                                                    )
                                                                                                    .map(size => ({ value: size.toString(), label: size.toString() }));

                                                                                                const afterBoldOptions = numericAllSizes
                                                                                                    .filter(size =>
                                                                                                        !recommendedRange ||
                                                                                                        size > recommendedRange.waistMax
                                                                                                    )
                                                                                                    .map(size => ({ value: size.toString(), label: size.toString() }));

                                                                                                const beforeBoldOptions = numericAllSizes
                                                                                                    .filter(size =>
                                                                                                        !recommendedRange ||
                                                                                                        size < recommendedRange.waistMin
                                                                                                    )
                                                                                                    .map(size => ({ value: size.toString(), label: size.toString() }));

                                                                                                // Final sorted options:
                                                                                                const sortedOptions = [
                                                                                                    { value: 'category', label: categoryName, isDisabled: true },
                                                                                                    ...boldOptions,
                                                                                                    ...afterBoldOptions,
                                                                                                    ...beforeBoldOptions
                                                                                                ];
                                                                                                return (
                                                                                                    <Select
                                                                                                        {...field}


                                                                                                        options={sortedOptions}

                                                                                                        placeholder="Select Waist Size"
                                                                                                        isClearable
                                                                                                        onChange={(selectedOption) => {
                                                                                                            const selectedValue = selectedOption ? selectedOption.value : '';
                                                                                                            field.onChange(selectedValue);
                                                                                                            if (!selectedValue) {
                                                                                                                setSizeRecommendationMsg("");
                                                                                                                checkPantSizeRanges(null, "waist");
                                                                                                                localStorage.removeItem('pantSizeRecommendationMsg');
                                                                                                                return;
                                                                                                            }

                                                                                                            checkPantSizeRanges(selectedValue, 'waist');

                                                                                                        }}
                                                                                                        value={
                                                                                                            field.value
                                                                                                                ? {
                                                                                                                    value: field.value,
                                                                                                                    label: field.value.toString(),
                                                                                                                    // isDisabled: false // Ensure the value can be selected
                                                                                                                }
                                                                                                                : null
                                                                                                        }



                                                                                                        formatOptionLabel={(option) => {
                                                                                                            let isBold = false;

                                                                                                            if (recommendedRange) {
                                                                                                                const { waistMin, waistMax } = recommendedRange;
                                                                                                                if (
                                                                                                                    Number(option.value) >= waistMin &&
                                                                                                                    Number(option.value) <= waistMax
                                                                                                                ) {
                                                                                                                    isBold = true;
                                                                                                                }
                                                                                                            }
                                                                                                            return (
                                                                                                                <div style={isBold ? { fontWeight: "bold" } : {}}>
                                                                                                                    {option.label}
                                                                                                                </div>
                                                                                                            );
                                                                                                        }}
                                                                                                    />
                                                                                                )
                                                                                            }}
                                                                                        />
                                                                                        {pantStyleSelected && errors.Waist && <p className='red'>{errors.Waist.message}</p>}
                                                                                        {pantValidationMessage && (
                                                                                            <p
                                                                                                style={{
                                                                                                    backgroundColor: '#FF0000',
                                                                                                    color: '#FFFFFF',
                                                                                                    fontSize: '12px',
                                                                                                    whiteSpace: 'nowrap',
                                                                                                    marginTop: '5px'
                                                                                                }}
                                                                                            >
                                                                                                {pantValidationMessage}
                                                                                            </p>
                                                                                        )}
                                                                                    </div>

                                                                                    {/* Hip Field */}
                                                                                    <div className="col-md-6 mb-3">
                                                                                        <label>Hip<span className="text-red-500"></span></label>
                                                                                        <Controller
                                                                                            name="hip"
                                                                                            control={control}
                                                                                            rules={{ required: false }}
                                                                                            render={({ field }) => {


                                                                                                const getSortedHipOptions = () => {
                                                                                                    const allSizes = (AllSize?.hipSizes || []).map(Number).sort((a, b) => a - b);

                                                                                                    if (recommendedRange && recommendedRange.hipMin && recommendedRange.hipMax) {
                                                                                                        const { hipMin, hipMax } = recommendedRange;

                                                                                                        const boldOptions = allSizes
                                                                                                            .filter(size => size >= hipMin && size <= hipMax)
                                                                                                            .map(size => ({ value: size.toString(), label: size.toString() }));

                                                                                                        const afterBoldOptions = allSizes
                                                                                                            .filter(size => size > hipMax)
                                                                                                            .map(size => ({ value: size.toString(), label: size.toString() }));

                                                                                                        const beforeBoldOptions = allSizes
                                                                                                            .filter(size => size < hipMin)
                                                                                                            .map(size => ({ value: size.toString(), label: size.toString() }));

                                                                                                        return [
                                                                                                            { value: 'category', label: categoryName, isDisabled: true },
                                                                                                            ...boldOptions,
                                                                                                            ...afterBoldOptions,
                                                                                                            ...beforeBoldOptions,
                                                                                                        ];
                                                                                                    } else {
                                                                                                        // Show all sizes when no recommendedRange
                                                                                                        const allOptions = allSizes.map(size => ({
                                                                                                            value: size.toString(),
                                                                                                            label: size.toString()
                                                                                                        }));

                                                                                                        return [
                                                                                                            { value: 'category', label: categoryName, isDisabled: true },
                                                                                                            ...allOptions
                                                                                                        ];
                                                                                                    }
                                                                                                };
                                                                                                return (
                                                                                                    <Select
                                                                                                        {...field}

                                                                                                        options={getSortedHipOptions()}
                                                                                                        placeholder="Select Hip Size"
                                                                                                        isClearable
                                                                                                        onChange={(selectedOption) => {
                                                                                                            const selectedValue = selectedOption ? selectedOption.value : '';
                                                                                                            field.onChange(selectedValue);
                                                                                                            if (!selectedValue) {
                                                                                                                // setSizeRecommendationMsg("");
                                                                                                                checkPantSizeRanges(null, "Hip");
                                                                                                                localStorage.removeItem('pantSizeRecommendationMsg');
                                                                                                                return;
                                                                                                            }
                                                                                                            checkPantSizeRanges(selectedValue, "Hip");
                                                                                                        }}
                                                                                                        value={
                                                                                                            field.value
                                                                                                                ? {
                                                                                                                    value: field.value,
                                                                                                                    label: field.value.toString(),
                                                                                                                    // This ensures the value exists in options
                                                                                                                    isDisabled: false
                                                                                                                }
                                                                                                                : null
                                                                                                        }


                                                                                                        formatOptionLabel={(option) => {
                                                                                                            const hipMin = recommendedRange?.hipMin;
                                                                                                            const hipMax = recommendedRange?.hipMax;
                                                                                                            const size = Number(option.value);

                                                                                                            const isBold = hipMin && hipMax && size >= hipMin && size <= hipMax;

                                                                                                            return (
                                                                                                                <div style={isBold ? { fontWeight: "bold" } : {}}>
                                                                                                                    {option.label}
                                                                                                                </div>
                                                                                                            );
                                                                                                        }}
                                                                                                    />
                                                                                                )
                                                                                            }}
                                                                                        />
                                                                                        {pantStyleSelected && errors.hip && <p className='red'>{errors.hip.message}</p>}
                                                                                    </div>


                                                                                    <div className="col-md-6 mb-3">
                                                                                        <label>Outseam<span className="text-red-500"></span></label>
                                                                                        <Controller
                                                                                            name="outseam"
                                                                                            control={control}
                                                                                            rules={{ required: false }}

                                                                                            // rules={{ required: pantStyleSelected ? "Outseam is required" : false }}
                                                                                            render={({ field }) => {

                                                                                                const getSortedOutseamOptions = () => {
                                                                                                    // Generate full range from 19 to 60 in 0.5 increments
                                                                                                    const fullRangeSizes = Array.from({ length: 83 }, (_, i) => 19 + i * 0.5);

                                                                                                    // Merge API-provided sizes with the full range
                                                                                                    const allSizes = Array.from(new Set([...(AllSize?.outseamSizes || []), ...fullRangeSizes]))
                                                                                                        .map(Number)
                                                                                                        .sort((a, b) => a - b);

                                                                                                    if (recommendedRange && recommendedRange.outseamMin && recommendedRange.outseamMax) {
                                                                                                        const { outseamMin, outseamMax } = recommendedRange;

                                                                                                        const boldOptions = allSizes
                                                                                                            .filter(size => size >= outseamMin && size <= outseamMax)
                                                                                                            .map(size => ({ value: size.toString(), label: size.toString() }));

                                                                                                        const afterBoldOptions = allSizes
                                                                                                            .filter(size => size > outseamMax)
                                                                                                            .map(size => ({ value: size.toString(), label: size.toString() }));

                                                                                                        const beforeBoldOptions = allSizes
                                                                                                            .filter(size => size < outseamMin)
                                                                                                            .map(size => ({ value: size.toString(), label: size.toString() }));

                                                                                                        return [
                                                                                                            { value: 'category', label: categoryName, isDisabled: true },
                                                                                                            ...boldOptions,
                                                                                                            ...afterBoldOptions,
                                                                                                            ...beforeBoldOptions,
                                                                                                        ];
                                                                                                    } else {
                                                                                                        // Show all sizes when no recommendedRange
                                                                                                        const allOptions = allSizes.map(size => ({
                                                                                                            value: size.toString(),
                                                                                                            label: size.toString()
                                                                                                        }));

                                                                                                        return [
                                                                                                            { value: 'category', label: categoryName, isDisabled: true },
                                                                                                            ...allOptions
                                                                                                        ];
                                                                                                    }
                                                                                                };
                                                                                                return (
                                                                                                    <Select
                                                                                                        {...field}

                                                                                                        options={getSortedOutseamOptions()}
                                                                                                        placeholder="Select Outseam Size"
                                                                                                        isClearable
                                                                                                        onChange={(selectedOption) => {
                                                                                                            const selectedValue = selectedOption ? selectedOption.value : '';
                                                                                                            field.onChange(selectedValue);
                                                                                                            if (!selectedValue) {
                                                                                                                // setSizeRecommendationMsg("");
                                                                                                                checkPantSizeRanges(null, "outseam");
                                                                                                                localStorage.removeItem('pantSizeRecommendationMsg');
                                                                                                                return;
                                                                                                            }
                                                                                                            checkPantSizeRanges(selectedValue, "Outseam");
                                                                                                        }}
                                                                                                        value={
                                                                                                            field.value
                                                                                                                ? {
                                                                                                                    value: field.value,
                                                                                                                    label: field.value.toString(),
                                                                                                                    // isDisabled: false // Important for selected value to appear in dropdown
                                                                                                                }
                                                                                                                : null
                                                                                                        }

                                                                                                        formatOptionLabel={(option) => {
                                                                                                            const outseamMin = recommendedRange?.outseamMin;
                                                                                                            const outseamMax = recommendedRange?.outseamMax;
                                                                                                            const size = Number(option.value);

                                                                                                            const isBold =
                                                                                                                outseamMin && outseamMax
                                                                                                                    ? size >= outseamMin && size <= outseamMax
                                                                                                                    : outseamSizes.map(Number).some(
                                                                                                                        (s) => size >= Math.min(...outseamSizes) && size <= Math.max(...outseamSizes)
                                                                                                                    );

                                                                                                            return (
                                                                                                                <div style={isBold ? { fontWeight: "bold" } : {}}>
                                                                                                                    {option.label}
                                                                                                                </div>
                                                                                                            );
                                                                                                        }}
                                                                                                    />
                                                                                                )
                                                                                            }}
                                                                                        />
                                                                                        {pantStyleSelected && errors.outseam && <p className='red'>{errors.outseam.message}</p>}
                                                                                    </div>

                                                                                    <div className="col-md-6 mb-3">
                                                                                        {shouldShowBelt && (
                                                                                            <>
                                                                                                <label>Belt Color</label>
                                                                                                <select
                                                                                                    {...register("belt")}
                                                                                                    value={currentBeltValue || ""}
                                                                                                    onChange={(e) => {
                                                                                                        setHasUserSelected(true);
                                                                                                        setValue("belt", e.target.value, { shouldValidate: true });
                                                                                                    }}
                                                                                                >
                                                                                                    <option value="">Select color</option>
                                                                                                    {availableColors.map(color => (
                                                                                                        <option value={color} key={color}>
                                                                                                            {color}
                                                                                                        </option>
                                                                                                    ))}
                                                                                                </select>
                                                                                            </>
                                                                                        )}
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                            <div className="col-md-4 addStyleMobileImg">
                                                                                {Pantstyle?.image ? (
                                                                                    <Image src={`${ImageUrl}${Pantstyle?.image}`} className="noSelectCoatImg" alt="" />
                                                                                ) : (
                                                                                    <img src="/assets/images/no-photo.png" className="selectCoatImg" alt="" />
                                                                                )}
                                                                            </div>
                                                                            {/* Size Recommendation Message */}
                                                                            {selectedHeight && sizeRecommendationMsg && (
                                                                                <div className="col-12 mb-3">
                                                                                    <span style={{
                                                                                        backgroundColor: 'lightyellow', // or use 'rgb(255, 255, 224)'
                                                                                        padding: '2px 12px',
                                                                                        borderRadius: '4px', color: 'black',
                                                                                    }} dangerouslySetInnerHTML={{ __html: sizeRecommendationMsg }}></span>

                                                                                </div>
                                                                            )}
                                                                        </div>
                                                                    </div>
                                                                </AccordionItem>
                                                                <AccordionItem
                                                                    id={3}
                                                                    title={
                                                                        LebelShirt?.style ? (
                                                                            <span className="fw-400">
                                                                                <strong className="fw-700">Shirt Style</strong> ({LebelShirt?.style} {LebelShirt?.description} -
                                                                                <span><strong className="fw-700">{LebelShirtsize ? LebelShirtsize : 'N/A'}</strong></span>)
                                                                            </span>
                                                                        ) : (
                                                                            <span><strong className="fw-700">Shirt Style</strong></span>
                                                                        )
                                                                    }
                                                                >
                                                                    <div class="accordion-inner">
                                                                        <div className="row">
                                                                            <div className="col-md-8 p-0 stateSelect">
                                                                                <div className="row">
                                                                                    <div className="col-md-6 mb-3">
                                                                                        <label>Shirt Style<span className="text-red-500"></span></label>
                                                                                        <Controller
                                                                                            name="Shirt"
                                                                                            control={control}
                                                                                            // rules={{ required: "Shirt is required" }}
                                                                                            render={({ field }) => (
                                                                                                <Select
                                                                                                    {...field}
                                                                                                    options={sortedShirts.map(item => ({
                                                                                                        value: `${item.style}`, // Combined value
                                                                                                        label: `${item.style} ${item.description}` // Combined label
                                                                                                    }))}
                                                                                                    placeholder="Select"
                                                                                                    components={customComponents}
                                                                                                    isClearable
                                                                                                    onChange={(selectedOption) => {
                                                                                                        const selectedValue = selectedOption ? selectedOption.value : '';
                                                                                                        field.onChange(selectedValue); // Update react-hook-form value

                                                                                                        // Call custom handler with synthetic event
                                                                                                        const syntheticEvent = { target: { value: selectedValue } };
                                                                                                        handleShirtChange(syntheticEvent);
                                                                                                        setValue("ShirtSize", ""); // Clears Neck
                                                                                                        setValue("Sleeve", "");    // Clears Sleeve
                                                                                                        setShirtSizeRecommendationMsg("");
                                                                                                    }}
                                                                                                    value={sortedShirts.map(item => ({
                                                                                                        value: `${item.style}`,
                                                                                                        label: `${item.style} ${item.description}`
                                                                                                    })).find(option => option.value === field.value) || null}
                                                                                                />
                                                                                            )}
                                                                                        />
                                                                                        {errors.Shirt && <p className='red'>{errors.Shirt.message}</p>}
                                                                                    </div>


                                                                                    <div className="col-md-6 mb-3">
                                                                                        <h6 className="mb-0 mt-1">{shirtstyleData?.style ? `#${shirtstyleData?.style}` : ''}</h6>
                                                                                        <p className="coatTxtPra"><small>{shirtstyleData?.description}</small></p>

                                                                                        {shirtSize && (
                                                                                            <p className="coatTxtPra">
                                                                                                <small><strong style={{ fontSize: "16px" }}>Shirt Size:</strong> <span style={{ fontSize: "16px" }}>{shirtSize}</span></small>

                                                                                            </p>
                                                                                        )}
                                                                                    </div>


                                                                                    <div className="col-md-6 mb-3">
                                                                                        <label>Neck<span className="text-red-500"></span></label>
                                                                                        <Controller
                                                                                            name="ShirtSize"
                                                                                            control={control}
                                                                                            rules={{ required: false }}

                                                                                            // rules={{ required: shirtStyleSelected ? "Neck size is required" : false }}
                                                                                            render={({ field }) => (
                                                                                                <Select
                                                                                                    {...field}
                                                                                                    options={neckSizeOptions}
                                                                                                    placeholder="Select Neck Size"
                                                                                                    isClearable
                                                                                                    value={field.value ? { value: field.value, label: field.value } : null}
                                                                                                    formatOptionLabel={(option) => (
                                                                                                        <div style={option.bold ? { fontWeight: 'bold' } : {}}>{option.label}</div>
                                                                                                    )}

                                                                                                    onChange={(selectedOption) => {
                                                                                                        const selectedValue = selectedOption ? selectedOption.value : '';

                                                                                                        field.onChange(selectedValue);
                                                                                                        handleNeckChange(selectedOption);

                                                                                                        if (!selectedValue) {
                                                                                                            setShirtSizeRecommendationMsg("");
                                                                                                            localStorage.removeItem('shirtSizeRecommendationMsg');
                                                                                                            return;
                                                                                                        }
                                                                                                        checkShirtSizeRanges(selectedOption, "ShirtSize");
                                                                                                    }}
                                                                                                />
                                                                                            )}
                                                                                        />
                                                                                        {errors.ShirtSize && <p className='red'>{errors.ShirtSize.message}</p>}
                                                                                    </div>

                                                                                    <div className="col-6 col-md-6 mb-3">
                                                                                        {showSleeve && (
                                                                                            <>
                                                                                                <label>Sleeve<span className="text-red-500"></span></label>
                                                                                                <Controller
                                                                                                    name="Sleeve"
                                                                                                    control={control}
                                                                                                    rules={{
                                                                                                        required: false
                                                                                                    }}
                                                                                                    render={({ field }) => (
                                                                                                        <Select
                                                                                                            {...field}

                                                                                                            options={filteredSleeveOptions}
                                                                                                            placeholder="Select Sleeve Size"
                                                                                                            isClearable
                                                                                                            isDisabled={disableSleeve}

                                                                                                            onChange={(selectedOption) => {
                                                                                                                checkShirtSizeRanges(selectedOption, "Sleeve")
                                                                                                                field.onChange(selectedOption ? selectedOption.value : '');
                                                                                                                checkShirtSizeRanges(selectedOption, "Sleeve");

                                                                                                            }}

                                                                                                            value={
                                                                                                                field.value ?
                                                                                                                    {
                                                                                                                        value: Number(field.value),
                                                                                                                        label: `${Number(field.value)}/${Number(field.value) + 1}`,
                                                                                                                    } : null
                                                                                                            }

                                                                                                            formatOptionLabel={(option) => {
                                                                                                                const parts = option.label.split('/').map(Number);
                                                                                                                const isBold = parts.some(val => InsleeveSizes.includes(val));

                                                                                                                return (
                                                                                                                    <div style={isBold ? { fontWeight: 'bold' } : {}}>
                                                                                                                        {option.label}
                                                                                                                    </div>
                                                                                                                );
                                                                                                            }}

                                                                                                        />
                                                                                                    )}
                                                                                                />
                                                                                                {errors.Sleeve && <p className='red'>{errors.Sleeve.message}</p>}</>)}
                                                                                    </div>

                                                                                </div>
                                                                            </div>
                                                                            <div className="col-md-4 addStyleMobileImg">
                                                                                {
                                                                                    shirtstyleData?.image ? <Image src={`${ImageUrl}${shirtstyleData?.image}`} className="noSelectCoatImg" alt="" />
                                                                                        : <img src="/assets/images/no-photo.png" className="selectCoatImg" alt />

                                                                                }
                                                                            </div>
                                                                            {selectedHeight && shirtSizeRecommendationMsg && (
                                                                                <div className="col-12 mb-3">
                                                                                    <span style={{
                                                                                        backgroundColor: 'lightyellow', // or use 'rgb(255, 255, 224)'
                                                                                        padding: '2px 12px',
                                                                                        borderRadius: '4px', color: 'black',
                                                                                    }} dangerouslySetInnerHTML={{ __html: shirtSizeRecommendationMsg }}></span>
                                                                                </div>
                                                                            )}
                                                                        </div>
                                                                    </div>
                                                                </AccordionItem>
                                                                <AccordionItem
                                                                    id={4}
                                                                    title={
                                                                        LebelVest?.style ? (
                                                                            <span className="fw-400">
                                                                                <strong className="fw-700">Vest Style</strong> ({LebelVest?.style} {LebelVest?.description} -
                                                                                <span><strong className="fw-700">{LebelVestsize ? LebelVestsize : 'N/A'}</strong></span>)
                                                                            </span>
                                                                        ) : (
                                                                            <span><strong className="fw-700">Vest Style</strong></span>
                                                                        )
                                                                    } >
                                                                    <div class="accordion-inner">
                                                                        <div className="row">
                                                                            <div className="col-md-12 p-0 stateSelect">
                                                                                <div className="row">
                                                                                    <div className="col-md-8 mb-3">
                                                                                        <div className="row">
                                                                                            <div className="col-md-6 mb-3">
                                                                                                <label>Vest Style <span className="text-red-500"></span></label>
                                                                                                <Controller
                                                                                                    name="Vest"
                                                                                                    control={control}
                                                                                                    render={({ field }) => (
                                                                                                        <Select
                                                                                                            {...field}
                                                                                                            options={sortedVest.map(item => ({
                                                                                                                value: item.style,
                                                                                                                label: `${item.style} ${item.description}`
                                                                                                            }))}
                                                                                                            placeholder="Select"
                                                                                                            components={customComponents}
                                                                                                            isClearable
                                                                                                            onChange={(selectedOption) => {
                                                                                                                // Update react-hook-form value
                                                                                                                field.onChange(selectedOption ? selectedOption.value : '');

                                                                                                                // Call custom handler with synthetic event
                                                                                                                const syntheticEvent = { target: { value: selectedOption ? selectedOption.value : '' } };
                                                                                                                handleVestChange(syntheticEvent);
                                                                                                            }}
                                                                                                            value={Vest.map(item => ({
                                                                                                                value: item.style,
                                                                                                                label: `${item.style} ${item.description}`
                                                                                                            })).find(option => option.value === field.value) || null}
                                                                                                        />
                                                                                                    )}
                                                                                                />
                                                                                                {errors.Vest && <p className='red'>{errors.Vest.message}</p>}
                                                                                            </div>

                                                                                            <div className="col-md-6 mb-3">
                                                                                                <h6 className="mb-0 mt-1">{Veststyle?.style ? `#${Veststyle?.style}` : ''}</h6>
                                                                                                <p className="coatTxtPra"><small>{Veststyle?.description}</small></p>
                                                                                            </div>
                                                                                            <div className="col-md-6 mb-3">
                                                                                                <label>Vest Size<span className="text-red-500"></span></label>
                                                                                                <Controller
                                                                                                    name="VestColor"
                                                                                                    control={control}
                                                                                                    rules={{ required: false }}

                                                                                                    render={({ field }) => {
                                                                                                        let uniqueSizes = [];

                                                                                                        if (coatid && sizesCategory && sizesCategory.length > 0) {
                                                                                                            uniqueSizes = sizesCategory
                                                                                                                .filter(size => size.vestSize != null && size.vestSize !== '')
                                                                                                                .map(size => size.vestSize);


                                                                                                        } else if (selectedHeight && watch("Weight")) {

                                                                                                            const weight = watch("Weight");
                                                                                                            const isWeightValid = weight !== null && weight !== undefined && !isNaN(weight) && weight !== "";

                                                                                                            if (isWeightValid) {
                                                                                                                const validSizeCharts = sizes
                                                                                                                    .flatMap(category => category.size_charts)
                                                                                                                    .filter(size =>
                                                                                                                        size.minHeight !== null &&
                                                                                                                        size.maxHeight !== null &&
                                                                                                                        selectedHeight >= size.minHeight &&
                                                                                                                        selectedHeight <= size.maxHeight
                                                                                                                    );

                                                                                                                const isWeightInRange = validSizeCharts.some(chart =>
                                                                                                                    (!chart.minWeight || Number(weight) >= chart.minWeight) &&
                                                                                                                    (!chart.maxWeight || Number(weight) <= chart.maxWeight)
                                                                                                                );

                                                                                                                if (isWeightInRange && validSizeCharts.length > 0) {
                                                                                                                    // Find the first valid category with size charts
                                                                                                                    let foundChart = null;
                                                                                                                    for (const category of sizes || []) {
                                                                                                                        if (category.size_charts && category.size_charts.length > 0) {
                                                                                                                            foundChart = category.size_charts[0];
                                                                                                                            break;
                                                                                                                        }
                                                                                                                    }

                                                                                                                    if (foundChart && foundChart.vestSize) {
                                                                                                                        uniqueSizes = [foundChart.vestSize];
                                                                                                                    }
                                                                                                                }
                                                                                                            }
                                                                                                        } else {
                                                                                                            // Case 3: No coat size and no valid height/weight
                                                                                                            uniqueSizes = [];
                                                                                                        }

                                                                                                        // Remove duplicates
                                                                                                        uniqueSizes = [...new Set(uniqueSizes)];



                                                                                                        // Filter only categories that have size charts
                                                                                                        const filteredCategories = sizes.filter(category => category.size_charts.length > 0);

                                                                                                        const availableCoatSizes = (AllSize?.vestSizes || []).map(size => ({
                                                                                                            value: size,
                                                                                                            label: size.toString(),
                                                                                                        }));
                                                                                                        const sortedAvailableCoatSizes = sortVestSizesWithLogic(availableCoatSizes, uniqueSizes);

                                                                                                        return (
                                                                                                            <Select
                                                                                                                {...field}
                                                                                                                // options={availableCoatSizes}
                                                                                                                options={sortedAvailableCoatSizes}
                                                                                                                placeholder="Select vest size"
                                                                                                                isClearable


                                                                                                                onChange={(selectedOption) => {
                                                                                                                    const selectedValue = selectedOption ? selectedOption.value : '';

                                                                                                                    field.onChange(selectedValue);

                                                                                                                    if (!selectedValue) {
                                                                                                                        setVestRecommendationMsg("");
                                                                                                                        localStorage.removeItem('vestRecommendationMsg');
                                                                                                                        return;
                                                                                                                    }

                                                                                                                    checkVestSizeRanges(selectedOption, "Vest");
                                                                                                                }}


                                                                                                                value={sortedAvailableCoatSizes.find(option => option.value === field.value) || null}

                                                                                                                formatOptionLabel={(option, { context }) => (
                                                                                                                    <div style={uniqueSizes.includes(option.value) ? { fontWeight: 'bold' } : {}}>
                                                                                                                        {option.label}
                                                                                                                    </div>
                                                                                                                )}
                                                                                                            />
                                                                                                        );
                                                                                                    }}
                                                                                                />
                                                                                                {errors.VestColor && <p className='red'>{errors.VestColor.message}</p>}
                                                                                            </div>
                                                                                        </div>
                                                                                    </div>

                                                                                    <div className="col-md-4 addStyleMobileImg">
                                                                                        {
                                                                                            Veststyle?.image ? <Image src={`${ImageUrl}${Veststyle?.image}`} className="noSelectCoatImg" alt="" />
                                                                                                : <img src="/assets/images/no-photo.png" className="selectCoatImg" alt />

                                                                                        }

                                                                                    </div>

                                                                                </div>



                                                                                {selectedHeight && vestRecommendationMsg && (
                                                                                    <div className="col-12 mb-3">
                                                                                        {/* <p >{vestRecommendationMsg}</p> */}
                                                                                        <span style={{
                                                                                            backgroundColor: 'lightyellow', // or use 'rgb(255, 255, 224)'
                                                                                            padding: '1px 2px',
                                                                                            borderRadius: '4px', color: 'black',
                                                                                        }} dangerouslySetInnerHTML={{ __html: vestRecommendationMsg }}></span>

                                                                                    </div>
                                                                                )}
                                                                            </div>
                                                                        </div>


                                                                    </div>
                                                                </AccordionItem>
                                                                <AccordionItem
                                                                    id={5}
                                                                    title={<span><strong className="fw-700">Tie, Pocket Square, Jewelry Style </strong></span>}
                                                                >
                                                                    <div className="accordion-inner">
                                                                        <div className="row">
                                                                            <div className="col-md-12 p-0 stateSelect">
                                                                                <div className="row">
                                                                                    <div className="col-md-6 mb-3">
                                                                                        <label>Tie <span className="text-red-500"></span></label>
                                                                                        <Controller
                                                                                            name="Tie"
                                                                                            control={control}
                                                                                            // rules={{ required: "Tie is required" }}
                                                                                            render={({ field }) => (
                                                                                                <Select
                                                                                                    {...field}
                                                                                                    options={sortedTie.map(item => ({
                                                                                                        value: item.style,
                                                                                                        label: `${item.style} ${item.description}`
                                                                                                    }))}
                                                                                                    placeholder="Select Tie"
                                                                                                    components={customComponents}
                                                                                                    isClearable
                                                                                                    onChange={(selectedOption) => {
                                                                                                        field.onChange(selectedOption ? selectedOption.value : '');
                                                                                                        const syntheticEvent = { target: { value: selectedOption ? selectedOption.value : '' } };
                                                                                                        handleTie(syntheticEvent);
                                                                                                    }}
                                                                                                    value={Tie.map(item => ({
                                                                                                        value: item.style,
                                                                                                        label: `${item.style} ${item.description}`
                                                                                                    })).find(option => option.value === field.value) || null}
                                                                                                />
                                                                                            )}
                                                                                        />
                                                                                        {errors.Tie && <p className='red'>{errors.Tie.message}</p>}
                                                                                    </div>

                                                                                    <div className="col-md-4 mb-3 " >
                                                                                        <label class="d-block" >Ordered For</label>


                                                                                        <ul className="custom-control-group">
                                                                                            <li>
                                                                                                <div className="custom-control custom-control-sm custom-radio custom-control-pro">
                                                                                                    <input
                                                                                                        type="radio"
                                                                                                        className="custom-control-input"
                                                                                                        name="btnRadio"
                                                                                                        id="btnRadio1"
                                                                                                        value="Men"
                                                                                                        {...register("order_for")}
                                                                                                        checked={orderForState == "Men"}
                                                                                                        onChange={(e) => {
                                                                                                            setOrderForState(e.target.value);
                                                                                                        }}
                                                                                                    // setValue("Height", ""); setSelectedHeight(''); 
                                                                                                    />
                                                                                                    <label className="custom-control-label" htmlFor="btnRadio1">Men</label>
                                                                                                </div>
                                                                                            </li>
                                                                                            <li>
                                                                                                <div className="custom-control custom-control-sm custom-radio custom-control-pro">
                                                                                                    <input
                                                                                                        type="radio"
                                                                                                        className="custom-control-input"
                                                                                                        name="btnRadio"
                                                                                                        id="btnRadio2"
                                                                                                        value="Boys"
                                                                                                        {...register("order_for")}
                                                                                                        checked={orderForState == "Boys"}
                                                                                                        onChange={(e) => {
                                                                                                            setOrderForState(e.target.value);

                                                                                                        }}
                                                                                                    />
                                                                                                    <label className="custom-control-label" htmlFor="btnRadio2">Boy</label>
                                                                                                </div>
                                                                                            </li>
                                                                                        </ul>
                                                                                    </div>

                                                                                    <div className="col-md-6 mb-3">
                                                                                        <label>Pocket Square <span className="text-red-500"></span></label>
                                                                                        <Controller
                                                                                            name="Pocket"
                                                                                            control={control}
                                                                                            // rules={{ required: "Pocket is required" }}
                                                                                            render={({ field }) => (
                                                                                                <Select
                                                                                                    {...field}
                                                                                                    options={sortedPocketSquare.map(item => ({
                                                                                                        value: `${item.style}`,
                                                                                                        label: `${item.style} ${item.description}`
                                                                                                    }))}
                                                                                                    placeholder="Select Pocket Square"
                                                                                                    components={customComponents}
                                                                                                    isClearable
                                                                                                    onChange={(selectedOption) => {
                                                                                                        field.onChange(selectedOption ? selectedOption.value : '');
                                                                                                        const syntheticEvent = { target: { value: selectedOption ? selectedOption.value : '' } };
                                                                                                        handlePocket(syntheticEvent);
                                                                                                    }}
                                                                                                    value={Pocket.map(item => ({
                                                                                                        value: `${item.style}`,
                                                                                                        label: `${item.style} ${item.description}`
                                                                                                    })).find(option => option.value === field.value) || null}
                                                                                                />
                                                                                            )}
                                                                                        />
                                                                                        {errors.Pocket && <p className='red'>{errors.Pocket.message}</p>}
                                                                                    </div>

                                                                                    <div className="col-md-6 mb-3">
                                                                                        <label>Jewelry<span className="text-red-500"></span></label>
                                                                                        <Controller
                                                                                            name="Jewelry"
                                                                                            control={control}
                                                                                            // rules={{ required: "Jewelry is required" }}
                                                                                            render={({ field }) => (
                                                                                                <Select
                                                                                                    {...field}
                                                                                                    options={sortedJewelry.map(item => ({
                                                                                                        value: item.style,
                                                                                                        label: `${item.style} ${item.description}`
                                                                                                    }))}
                                                                                                    placeholder="Select Jewelry"
                                                                                                    components={customComponents}
                                                                                                    isClearable
                                                                                                    onChange={(selectedOption) => {
                                                                                                        field.onChange(selectedOption ? selectedOption.value : '');
                                                                                                        const syntheticEvent = { target: { value: selectedOption ? selectedOption.value : '' } };

                                                                                                        handlejwellaryChange(syntheticEvent);

                                                                                                    }}
                                                                                                    value={Jewelry.map(item => ({
                                                                                                        value: item.style,
                                                                                                        label: `${item.style} ${item.description}`
                                                                                                    })).find(option => option.value === field.value) || null}
                                                                                                />
                                                                                            )}
                                                                                        />
                                                                                        {errors.Jewelry && <p className='red'>{errors.Jewelry.message}</p>}
                                                                                    </div>

                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </AccordionItem>
                                                                <AccordionItem
                                                                    id={6}
                                                                    title={
                                                                        LebelShoes?.style ? (
                                                                            <span className="fw-400">
                                                                                <strong className="fw-700">Shoe Style</strong> ({LebelShoes?.style} {LebelShoes?.description} -
                                                                                <span><strong className="fw-700">{LebelShoessize ? LebelShoessize : 'N/A'}</strong></span>)
                                                                            </span>
                                                                        ) : (
                                                                            <span><strong className="fw-700">Shoe Style</strong></span>
                                                                        )
                                                                    }>
                                                                    <div className="accordion-inner">
                                                                        <div className="row">
                                                                            <div className="col-md-12 p-0 stateSelect">
                                                                                <div className="row">
                                                                                    <div className="col-md-8 mb-3">
                                                                                        <div className="row">
                                                                                            <div className="col-md-6 mb-3">
                                                                                                <label> Shoe Style <span className="text-red-500"></span></label>
                                                                                                <Controller
                                                                                                    name="Shoes"
                                                                                                    control={control}
                                                                                                    rules={{ required: selectedShoesStyle ? "Shoe is required" : false }}
                                                                                                    // rules={{ required: selectedShoesStyle ? "Shoes is required" : false }}

                                                                                                    render={({ field }) => (
                                                                                                        <Select
                                                                                                            {...field}
                                                                                                            options={sortedShoes.map(item => ({
                                                                                                                value: `${item.style}`,
                                                                                                                label: `${item.style} ${item.description}`,
                                                                                                                shoeColor: item.shoe_color
                                                                                                            }))}
                                                                                                            placeholder="Select shoe"
                                                                                                            components={customComponents}
                                                                                                            isClearable
                                                                                                            onChange={(selectedOption) => {
                                                                                                                // Update react-hook-form value
                                                                                                                field.onChange(selectedOption ? selectedOption.value : '');
                                                                                                                if (selectedOption && selectedOption.shoeColor) {
                                                                                                                    setValue('shoe_color', selectedOption.shoeColor);
                                                                                                                } else {
                                                                                                                    setValue('shoe_color', ''); // Clear if no selection
                                                                                                                }
                                                                                                                // Call custom handler with synthetic event
                                                                                                                const syntheticEvent = { target: { value: selectedOption ? selectedOption.value : '' } };
                                                                                                                handleShoes(syntheticEvent);
                                                                                                            }}
                                                                                                            value={Shoes.map(item => ({
                                                                                                                value: `${item.style}`,
                                                                                                                label: `${item.style} ${item.description}`,
                                                                                                                shoeColor: item.shoe_color
                                                                                                            })).find(option => option.value === field.value) || null}
                                                                                                        />
                                                                                                    )}
                                                                                                />
                                                                                                {errors.Shoes && <p className='red'>{errors.Shoes.message}</p>}
                                                                                            </div>

                                                                                            <div className="col-md-6 mb-3">
                                                                                                <label>Shoe Size<span className="text-red-500"></span></label>
                                                                                                <Controller
                                                                                                    name="ShoesSize"
                                                                                                    control={control}
                                                                                                    rules={{
                                                                                                        required: false, // Only required when Shoes is selected
                                                                                                    }}
                                                                                                    render={({ field }) => (
                                                                                                        <Select
                                                                                                            {...field}

                                                                                                            options={[
                                                                                                                ...ShoeSizes.map(size => ({
                                                                                                                    value: size,
                                                                                                                    label: size // Highlight Boys' sizes (you can style this with CSS instead)
                                                                                                                })),
                                                                                                            ]}


                                                                                                            placeholder="Select size"
                                                                                                            isClearable
                                                                                                            onChange={(selectedOption) => {
                                                                                                                field.onChange(selectedOption ? selectedOption.value : '');
                                                                                                            }}

                                                                                                            value={
                                                                                                                ShoeSizes.map(size => ({
                                                                                                                    value: size,
                                                                                                                    label: size
                                                                                                                }))
                                                                                                                    .find(option => option.value === field.value) || null
                                                                                                            }

                                                                                                        />
                                                                                                    )}
                                                                                                />
                                                                                                {errors.ShoesSize && <p className='red'>{errors.ShoesSize.message}</p>}
                                                                                            </div>
                                                                                            <div className="col-md-6 mb-3">
                                                                                                <label>
                                                                                                    Shoe Color<span className="text-red-500">*</span>
                                                                                                </label>
                                                                                                <Controller
                                                                                                    name="shoe_color"
                                                                                                    control={control}
                                                                                                    render={({ field, fieldState: { error } }) => {
                                                                                                        const selectedColor = shoeColors
                                                                                                            .map(color => ({ value: color, label: color }))
                                                                                                            .find(option => option.value === field.value);

                                                                                                        return (
                                                                                                            <>
                                                                                                                <div
                                                                                                                    style={{
                                                                                                                        padding: '8px 12px',
                                                                                                                        border: '1px solid #ccc',
                                                                                                                        borderRadius: '4px',
                                                                                                                        backgroundColor: '#f8f9fa',
                                                                                                                        color: '#495057',
                                                                                                                        cursor: 'not-allowed',
                                                                                                                        minHeight: '38px',
                                                                                                                        display: 'flex',
                                                                                                                        alignItems: 'center',
                                                                                                                    }}
                                                                                                                >
                                                                                                                    {selectedColor ? selectedColor.label : 'No color selected'}
                                                                                                                </div>
                                                                                                                {error && (
                                                                                                                    <span
                                                                                                                        style={{
                                                                                                                            backgroundColor: '#FF0000',
                                                                                                                            color: '#FFFFFF',
                                                                                                                            marginTop: '10px',
                                                                                                                            fontSize: '14px',
                                                                                                                            display: 'inline-block',
                                                                                                                        }}
                                                                                                                    >
                                                                                                                        {error.message}
                                                                                                                    </span>
                                                                                                                )}
                                                                                                            </>
                                                                                                        );
                                                                                                    }}
                                                                                                />
                                                                                            </div>
                                                                                        </div>
                                                                                    </div>
                                                                                    <div className="col-md-4 addStyleMobileImg">
                                                                                        {ShoesData?.image ? (
                                                                                            <Image src={`${ImageUrl}${ShoesData?.image}`} className="noSelectCoatImg" alt="" />
                                                                                        ) : (
                                                                                            <img src="/assets/images/no-photo.png" className="selectCoatImg" alt="" />
                                                                                        )}
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </AccordionItem>
                                                            </div>
                                                        </div>


                                                        <div className="col-md-12">
                                                            <div className="row align-items-center">
                                                                <div className="col-md-6 mb-3">
                                                                    <label className="form-label">Rental Weeks <span className="text-red-500">*</span></label>
                                                                    <select
                                                                        {...register("Rentalterm")}
                                                                        className="form-select"
                                                                    >
                                                                        <option value="">Select week</option>
                                                                        <option value="1 week">1 week</option>
                                                                        <option value="2 weeks">2 weeks</option>
                                                                        <option value="3 weeks">3 weeks</option>
                                                                        <option value="4 weeks">4 weeks</option>
                                                                    </select>
                                                                    {errors.Rentalterm && <div className="text-danger small mt-1">{errors.Rentalterm.message}</div>}
                                                                </div>
                                                            </div>

                                                            <div className="row">
                                                                <div class="col-md-12 mt-3">
                                                                    <a className="backBtnWedding" style={{ cursor: "pointer" }} onClick={handleBack}>Back</a>
                                                                    <button
                                                                        type="submit"
                                                                        className="addBtnCustomer"
                                                                        onClick={(e) => {
                                                                            const formHasErrors = Object.keys(formState.errors).length > 0 || !!categoryValidationMessage;
                                                                            if (formHasErrors) {
                                                                                e.preventDefault();
                                                                                openAccordionWithErrors(formState.errors, !!categoryValidationMessage);
                                                                                if (categoryValidationMessage && categoryErrorRef.current) {
                                                                                    categoryErrorRef.current.scrollIntoView({ behavior: 'smooth', block: 'center' });
                                                                                }
                                                                                return;
                                                                            }
                                                                            if (formHasErrors) {
                                                                                e.preventDefault(); // Prevent form submission
                                                                                openAccordionWithErrors(formState.errors);
                                                                                return;
                                                                            }
                                                                        }}
                                                                    >
                                                                        Continue
                                                                    </button></div>
                                                            </div>
                                                        </div>
                                                    </div >
                                                </form >
                                            </div >
                                        </div >
                                    </div >
                                </div >
                            </div >
                        </div >
                    </div >
                </div >
            </div >


            <div class="modal fade" tabindex="-1" id="alterationsCoatModal">
                <div class="modal-dialog modal-lg" role="document">
                    <div class="modal-content">
                        <div class="modal-body p-0">
                            <div class="alterModalContent">
                                <div class="leftImage">
                                    <img src="assets/images/modal.png" alt="" />
                                </div>
                                <div class="contentModalRight">
                                    <div class="modal-header plModal">
                                        <h5 class="modal-title f12Size">Messages </h5>
                                        <a href="#" class="close" data-bs-dismiss="modal" aria-label="Close">
                                            <em class="icon ni ni-cross-c"></em>
                                        </a>
                                    </div>

                                    <h3>Cost for sleeve alterations are $6.00 per coat</h3>
                                    <p>Please allow 1/2" tolerance.</p>
                                    <a href="" class="okayBtn" data-bs-dismiss="modal" aria-label="Close">Okay</a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Container >
    )
}

export default Memberstyle
